<template>
    <div class="md-card">
        <div class="roster-request md-card-body" style="overflow-y: auto; padding-bottom: 60px">
            <div>
                <!-- STAGE 1: POSITIONEN-->
                <section v-if="state === 1" class="md-card-body">
                    <h3 class="md-header">{{ $t('roster.main.shiftPositions') }}</h3>
                    <datatablesimple :state="spotOptionsState" class="md-card-select small-table"/>
                </section>
                <!-- STAGE 2: POSITIONEN-->
                <section v-if="state === 2" class="md-card-body">
                    <h3 class="md-header">{{ $tc('global.general.employee', 2) }}</h3>
                    <div v-bind:key="employeeId" v-for="(employee, employeeId) in employeeInfos" class="md-card-select"
                    style="border-bottom: 1px solid var(--md)">
                        <labelc type="header" class="wide-label" :text="employee.name"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="employeeId"
                                @click="toggleSimpleEntries(employeeId, 'employeeOptions', employeeId)"/>
                        <labelc type="header" :text="employee.show ? '⏶' : '⏷'" style="width: auto"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="employeeId"
                                @click="toggleSimpleEntries(employeeId, 'employeeOptions', employeeId)"/>
                        <div v-if="employee.show">
                            <div class="md-card-select" style="border: none">
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.planType')" :styleText="{marginLeft: '0'}" />
                                    <div> {{ employee.type.name }}</div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.weeklyTargetHours')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.weekTimeRegularMin,
                                    max: employee.typeTemplate.weekTimeRegularMax, value: employee.type.weekTimeRegular,
                                    DisplayLabel: (val) => {return val / 60}, step: 15, object: employee,
                                    inputControl: true, sliderInput: (x) => { return x * 60}}"
                                                @callback="updateEmployeeInfoMonthTimeRegular" />
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.monthlyTargetHours')" :styleText="{marginLeft: '0'}" />
                                    <div> {{ employee.type.monthTimeRegular / 60 }}</div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.planningType')" :styleText="{marginLeft: '0'}"
                                            :style-label="styleLabelLeft"/>
                                    <select disabled v-model.number="employee.type.monthTimeMaxType"
                                            style="max-width: 70%">
                                        <option value="1">
                                            {{ $t('roster.main.exceedFreely') }}
                                        </option>
                                        <option value="2">
                                            {{ $t('roster.main.limitedExceed') }}
                                        </option>
                                        <option value="3">
                                            {{ $t('roster.main.doNotExceed') }}
                                        </option>
                                    </select>
                                </div>
                                <div class="md-group" v-if="employee.type.monthTimeMaxType===2">
                                    <labelc type="header" class="label" :text="$t('roster.main.monthTargetBuffer')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.monthTimeMaxAdjustmentMin,
                                        max: employee.typeTemplate.monthTimeMaxAdjustmentMax,
                                        value: employee.type.monthTimeMaxAdjustment,
                                        DisplayLabel: (val) => {return val / 60},inputControl: true, sliderInput: (x) => { return x * 60},
                                         step: 15, object: employee}" @callback="updateEmployeeInfoMonthTimeMaxAdjustment"/>
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.weeklyMaxHours')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.weekTimeMaxMin,
                                     max: employee.typeTemplate.weekTimeMaxMax, value: employee.type.weekTimeMax,
                                      DisplayLabel: (val) => {return val / 60},inputControl: true, sliderInput: (x) => { return x * 60},
                                       step: 15, object: employee}" @callback="updateEmployeeInfoWeekTimeMax" />
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.weeklyAverageType')" :styleText="{marginLeft: '0'}"
                                            :style-label="styleLabelLeft"/>
                                    <select disabled v-model.number="employee.type.weekTimeAvgType"
                                            style="max-width: 70%">
                                        <option value="1">
                                            {{ $t('roster.main.weeklyExceedFreely') }}
                                        </option>
                                        <option value="2">
                                            {{ $t('roster.main.limitedWeeklyExceed') }}
                                        </option>
                                        <option value="3">
                                            {{ $t('roster.main.doNotExceedWeekly') }}
                                        </option>
                                    </select>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.weeklyTargetWorkDays')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.weekWorkDaysRegularMin,
                                     max: employee.typeTemplate.weekWorkDaysRegularMax,
                                      value: employee.type.weekWorkDaysRegular, object: employee,inputControl: true,
                                       sliderInput: (x) => { return x}}" @callback="updateEmployeeInfoWeekWorkDaysRegular" />
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.dailyTargetHours')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.dayTimeRegularMin,
                                     max: employee.typeTemplate.dayTimeRegularMax, value: employee.type.dayTimeRegular,
                                       DisplayLabel: (val) => {return val / 60}, step: 15, object: employee,inputControl: true,
                                       sliderInput: (x) => { return x * 60}}" @callback="updateEmployeeInfoDayTimeRegular" />
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.dailyMaxHours')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.dayTimeMaxMin,
                                     max: employee.typeTemplate.dayTimeMaxMax, value: employee.type.dayTimeMax,
                                      DisplayLabel: (val) => {return val / 60},inputControl: true, sliderInput: (x) => { return x * 60},
                                        step: 15, object: employee}" @callback="updateEmployeeInfoDayTimeMax" />
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.restTime')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.restTimeMin,
                                     max: employee.typeTemplate.restTimeMax, value: employee.type.restTime,
                                      DisplayLabel: (val) => {return val / 60},inputControl: true, sliderInput: (x) => { return x * 60},
                                       step: 15, object: employee}" @callback="updateEmployeeInfoRestTime" />
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.freeTimeWeekly')" :styleText="{marginLeft: '0'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: employee.typeTemplate.weekSpareDaysMinMin,
                                     max: employee.typeTemplate.weekSpareDaysMinMax,
                                      value: employee.type.weekSpareDaysMin, object: employee, inputControl: true,
                                       sliderInput: (x) => { return x}}" @callback="updateEmployeeInfoWeekSpareDaysMin" />
                                    </div>
                                </div>
                                <div class="md-group">

                                    <labelc type="header" class="label" :text="$t('store.templates.additionalFreeTime')" :styleText="{marginLeft: '0'}" />
                                    <div> {{
                                            Math.floor(employee.typeTemplate.weekSpareTimeMinMin / 60) - (employee.typeTemplate.weekSpareDaysMinMin * 24)
                                        }}
                                    </div>
                                </div>
                                <div class="md-group">
                                    <labelc type="header" class="label" :text="$t('roster.main.freeTimeStartType')" :styleText="{marginLeft: '0'}"
                                            :style-label="styleLabelLeft"/>
                                    <select disabled v-model.number="employee.type.weekSpareTimeStartType"
                                            style="max-width: 70%">
                                        <option value="1">
                                            Mindest Wochen Freizeit kann zu jeder Uhrzeit beginnen
                                        </option>
                                        <option value="2">
                                            Mindest Wochen Freizeit soll möglichst nahe an Ziel Uhrzeit beginnen
                                        </option>
                                        <option value="3">
                                            Mindest Wochen Freizeit muss vor Ziel Uhrzeit beginnen
                                        </option>
                                    </select>
                                </div>
                                <div class="md-group" v-if="employee.typeTemplate.shiftBetweenTimeMinMin > -1">
                                    <h4>{{ $t('roster.comp.multipleShifts') }}</h4>
                                    <div class="md-group">
                                        <labelc type="header" class="label" :text="$t('roster.main.minTimeBetweenShifts')" :styleText="{marginLeft: '0'}" />
                                        <div class="slide-container">
                                            <slider :state="{min: employee.typeTemplate.shiftBetweenTimeMinMin,
                                         max: employee.typeTemplate.shiftBetweenTimeMinMax,
                                          value: employee.type.shiftBetweenTimeMin, DisplayLabel: (val) => {return val / 60},
                                           inputControl: true, sliderInput: (x) => { return x * 60}, step: 15,
                                            object: employee}" @callback="updateEmployeeInfoShiftTimeBetweenMin" />
                                        </div>
                                    </div>
                                    <div class="md-group">
                                        <labelc type="header" class="label" :text="$t('roster.main.maxTimeBetweenShifts')" :styleText="{marginLeft: '0'}" />
                                        <div class="slide-container">
                                            <slider :state="{min: employee.typeTemplate.shiftBetweenTimeMaxMin,
                                         max: employee.typeTemplate.shiftBetweenTimeMaxMax,
                                          value: employee.type.shiftBetweenTimeMax,
                                           DisplayLabel: (val) => {return val / 60}, inputControl: true, sliderInput: (x) => { return x * 60},
                                            step: 15, object: employee}" @callback="updateEmployeeInfoShiftTimeBetweenMax"></slider>
                                        </div>
                                    </div>
                                </div>
                                <div class="md-group" v-if="employee.typeTemplate.daysConsecutiveMaxMin > -1">
                                    <h4>{{ $t('roster.comp.limitFollowupDay') }}</h4>
                                    <div class="md-group">
                                        <labelc type="header" class="label"
                                                :text="$t('roster.main.maxConsecutiveDays')" :styleText="{marginLeft: '0'}" />
                                        <div class="slide-container">
                                            <slider :state="{min: employee.typeTemplate.daysConsecutiveMaxMin,
                                         max: employee.typeTemplate.daysConsecutiveMaxMax, inputControl: true,
                                          sliderInput: (x) => { return x}, value: employee.type.daysConsecutiveMax, object: employee}"
                                                    @callback="updateEmployeeInfoDaysConsecutiveMax"></slider>
                                        </div>
                                    </div>
                                </div>
                                <div class="md-group" v-if="employee.typeTemplate.monthOvertimeMaxMin > -1">
                                    <h4>{{ $t('store.templates.limitOvertime') }}</h4>
                                    <div class="md-group">
                                        <labelc type="header" class="label" :text="$t('roster.main.maxOvertimeMonth')" :styleText="{marginLeft: '0'}" />
                                        <div class="slide-container">
                                            <slider :state="{min: employee.typeTemplate.monthOvertimeMaxMin,
                                         max: employee.typeTemplate.monthOvertimeMaxMax,
                                          value: employee.type.monthOvertimeMax, DisplayLabel: (val) => {return val / 60},
                                           inputControl: true, sliderInput: (x) => { return x * 60}, step: 15, object: employee}"
                                                    @callback="updateEmployeeInfoMonthOvertimeMax" />
                                        </div>
                                    </div>
                                </div>
                                <div class="md-group" v-if="employee.typeTemplate.weekWorkDaysMaxMin > -1">
                                    <h4> {{ $t('store.templates.limitWorkDaysWeek') }}</h4>
                                    <div class="md-group">
                                        <labelc type="header" class="label" :text="$t('roster.main.maxWorkDaysWeek')" :styleText="{marginLeft: '0'}" />
                                        <div class="slide-container">
                                            <slider :state="{min: employee.typeTemplate.weekWorkDaysMaxMin,
                                         max: employee.typeTemplate.weekWorkDaysMaxMax, inputControl: true,
                                       sliderInput: (x) => { return x}, value: employee.type.weekWorkDaysMax, object: employee}"
                                                    @callback="updateEmployeeInfoWeekWorkDaysMax" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- STAGE 3: Verfügbarkeiten-->
                <section v-if="state === 3" class="md-card-body">
                    <h3 class="md-header">{{ $t('roster.main.employeeAvailabilities') }}</h3>
                    <div v-bind:key="'employeeAvailability '+accordionEntry.id"
                         v-for="accordionEntry in employeeAvailabilityEmployeeAccordionEntries"
                         style="border-bottom: 1px solid var(--md)">
                        <labelc type="header" class="w400" :text="accordionEntry.label"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" ref="comp"
                                @click="toggleAccordionEntries(accordionEntry, 'employeeAvailabilityOptions')" />
                        <labelc type="header" :text="accordionEntry.show ? '⏶' : '⏷'" style="width: auto"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" ref="comp"
                                @click="toggleAccordionEntries(accordionEntry, 'employeeAvailabilityOptions')" />
                        <div v-if="accordionEntry.show" class="md-group">
                            <availabilitytable :items="accordionEntry.entries" :presence="true" style="width: 100%"
                                               :stateMap="employeeAvailabilityStateMap" />
                        </div>
                    </div>

                    <h3 class="md-header">{{ $t('roster.main.employeeAbsencesPreferences') }}</h3>
                    <div v-bind:key="'employeePeference '+accordionEntry.id"
                         v-for="accordionEntry in employeePreferenceEmployeeAccordionEntries"
                         style="border-bottom: 1px solid var(--md)">
                        <labelc type="header" class="w400" :text="accordionEntry.label"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" ref="comp"
                                @click="toggleAccordionEntries(accordionEntry, 'employeePreferenceOptions')"/>
                        <labelc type="header" :text="accordionEntry.show ? '⏶' : '⏷'" style="width: auto"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" ref="comp"
                                @click="toggleAccordionEntries(accordionEntry, 'employeePreferenceOptions')"/>
                        <div v-if="accordionEntry.show" class="md-group">
                            <availabilitytable :items="accordionEntry.entries" :presence="false" style="width: 100%"
                                               :stateMap="employeeAvailabilityStateMap"
                                               :typeMap="employeeAvailabilityTypeMap" />
                        </div>
                    </div>
                </section>
                <!-- STAGE 4: SHIFTS-->
                <section v-if="state === 4" class="md-card-body">
                    <h3 class="md-header">{{ $t('shift.main.planShifts') + ': ' + selectedShiftIds.length }}</h3>
                    <div v-bind:key="'planShifts '+accordionEntry.id"
                         v-for="accordionEntry in planshiftWeekAccordionEntries"
                         style="border-bottom: 1px solid var(--md)">
                        <labelc type="header" class="w400" :text="accordionEntry.id"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="'planShifts '+accordionEntry.id"
                                @click="toggleAccordionEntries(accordionEntry, 'shiftOptions',
                                 'planShifts '+accordionEntry.id)"/>
                        <labelc type="header" :text="accordionEntry.show ? '⏶' : '⏷'" style="width: auto"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="'planShifts '+accordionEntry.id"
                                @click="toggleAccordionEntries(accordionEntry, 'shiftOptions')"/>
                        <div v-if="accordionEntry.show">
                            <shifttable :items="accordionEntry.entries" :checked="true"
                                        class="md-card-select" style="width: 100%; border: none" />
                        </div>
                    </div>

                    <h3 class="md-header">{{ $t('roster.main.unfillableShifts')  +  ': ' + impossibleShiftOptions.length }}</h3>
                    <div v-bind:key="'impossibleShifts '+accordionEntry.id"
                         v-for="accordionEntry in impossiblePlanshiftWeekAccordionEntries"
                         style="border-bottom: 1px solid var(--md)">
                        <labelc type="header" class="w400" :text="accordionEntry.id"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="'impossibleShifts '+accordionEntry.id"
                                @click="toggleAccordionEntries(accordionEntry, 'impossibleShiftOptions',
                                 'impossibleShifts '+accordionEntry.id)"/>
                        <labelc type="header" :text="accordionEntry.show ? '⏶' : '⏷'" style="width: auto"
                                :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="'impossibleShifts '+accordionEntry.id"
                                @click="toggleAccordionEntries(accordionEntry, 'impossibleShiftOptions')"/>
                        <div v-if="accordionEntry.show">
                            <shifttable :items="accordionEntry.entries" :checked="false"
                                        class="md-card-select" style="width: 100%; border: none" />
                        </div>
                    </div>

                    <checkboxgroup :value="useActualShifts" :text="$t('roster.main.usePunchTimes')"
                                   :id="'useActualShifts'" :toggleBoolean="toggleBoolean"/>
                    <div v-if="useActualShifts">
                        <h3 class="md-header">{{ $t('shift.plan.punchTimes') }} : {{ actualShiftOptions.length }}</h3>
                        <div v-bind:key="'actualShifts '+accordionEntry.id"
                             v-for="accordionEntry in actualShiftWeekAccordionEntries"
                             style="border-bottom: 1px solid var(--md)">
                            <labelc type="header" class="wide-label" :text="accordionEntry.id"
                                    :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="'actualShifts '+accordionEntry.id"
                                    @click="toggleAccordionEntries(accordionEntry, 'actualShiftOptions',
                                     'actualShifts '+accordionEntry.id)"/>
                            <labelc type="header" :text="accordionEntry.show ? '⏶' : '⏷'" style="width: auto"
                                    :styleText="{marginLeft: '0', fontSize: '22px'}" :ref="'actualShifts '+accordionEntry.id"
                                    @click="toggleAccordionEntries(accordionEntry, 'actualShiftOptions')"/>
                            <div v-if="accordionEntry.show">
                                <shifttable :items="accordionEntry.entries" :checked="false"
                                            class="md-card-select" style="width: 100%; border: none" />
                            </div>
                        </div>
                    </div>

                </section>
                <!-- STAGE 5: Regeln auswählen + Planzeit-->
                <section v-if="state === 5" class="md-card-body">
                    <h3 class="md-header">{{ $t('roster.main.automaticRoster') }}</h3>
                    <div class="md-card-select tabbar" style="margin-top: 35px;">
                        <menutabs :state="{tabs: tabs}" :tab-selected="selectedTab" @tab-select="UpdateRosterRequestTab"
                                  :disabled="false"></menutabs>
                    </div>
                    <div style="border-top: 1px solid var(--contrast-3)"
                         v-bind:style="{'border-bottom': this.tabSelected === '' ? 'none' : ''}">
                        <div v-if="tabSelected === 'configSelection'" class="md-tab-body">
                            <div class="md-card-select pad-top-bottom">
                                    <labelc type="header" class="label" :text="$t('roster.main.planProfile')" :styleText="{marginLeft: '0', 'margin-bottom': '4px'}" />
                                    <dropdownsearch class="dropdown" :state="ruleProfileState"
                                                    @item-selected="updateRuleProfile"></dropdownsearch>
                                    <labelc type="header" class="label" :text="$t('roster.main.planningFrom')" :styleText="{marginLeft: '4px', 'margin-bottom': '4px', 'padding-left': '8px', 'border-left': 'solid 1px var(--contrast-3)'}" />
                                    <dropdownsearch class="dropdown" :state="planFromState"
                                                    @item-selected="updatePlanFrom"></dropdownsearch>
                                    <labelc type="header" class="label" :text="$t('roster.main.planningTill')" :styleText="{marginLeft: '4px', 'margin-bottom': '4px', 'padding-left': '8px', 'border-left': 'solid 1px var(--contrast-3)'}" />
                                    <dropdownsearch class="dropdown" :state="planToState"
                                                    @item-selected="updatePlanTo"></dropdownsearch>
                            </div>
                            <div class="md-card-select pad-top-bottom" style="border-bottom: none;">
                                <div class="md-group inline border-right">
                                    <labelc type="header" class="label" :text="$t('roster.main.targetWorkTime')" :styleText="{marginLeft: '0', 'margin-top': '12px'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: 0, max: 100, hideMin:true, hideMax: true,
                                            value: monthTimeRegularPercentage, DisplayLabel: (val) => {return val + '%' },
                                            inputControl: true, sliderInput: (x) => {return x},
                                            labelToInt: (x) => {return x.slice(0, -1)}, step: 5, object: this}"
                                            @callback="updateMonthTimeRegularPercentage" />
                                    </div>
                                </div>
                                <div class="md-group inline border-right">
                                    <labelc type="header" class="label" :text="$t('roster.main.calcDuration')" :styleText="{marginLeft: '0', 'margin-top': '12px'}" />
                                    <div class="slide-container">
                                        <slider :state="{min: 5, max: 60, hideMin:false, hideMax: false,
                                            value: planRunTime, DisplayLabel: (val) => {return val +'min.' }, inputControl: true,
                                            sliderInput: (x) => {return x}, labelToInt: (x) => {return x.slice(0, -4)},
                                            step: 1, object: this}" @callback="updatePlanRunTime" />
                                    </div>
                                </div>
                                <div class="md-group inline" style="margin-top: 12px;">
                                    <labelc v-if="isSuperUser" type="header" class="label" :text="$t('roster.main.highPerformance')" :styleText="{marginLeft: '0'}" />
                                    <div class="cb-group" v-if="isSuperUser" @click="toggleBoolean(hp, 'hp')">
                                        <checkbox :disabled="!isSuperUser" id="highperf" :value="hp" :toggle-check="true" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="tabSelected === 'ruleSelection'" class="md-tab-body">
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" class="header" :text="$t('roster.main.fixedRules')" ref="showDefaultRules"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        @click="toggleDropdown('showDefaultRules')" />
                                <labelc type="header" class="header" :text="showDefaultRules ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('showDefaultRules')" />
                                <rulesgroup v-if="showDefaultRules" :rules="defaultRules()" class="md-group" />
                            </div>
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" :text="$t('roster.main.planningBaseRules')" ref="showEmployeeTypeRules"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        @click="toggleDropdown('showEmployeeTypeRules')" />
                                <labelc type="header" :text="showEmployeeTypeRules ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('showEmployeeTypeRules')" />
                                <rulesgroup v-if="showEmployeeTypeRules" :rules="employeeTypeRules()"/>
                            </div>
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" class="header" :text="$t('roster.main.freeTimeRules')" ref="showSpareTimeRules"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        @click="toggleDropdown('showSpareTimeRules')" />
                                <labelc type="header" class="header" :text="showSpareTimeRules ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('showSpareTimeRules')" />
                                <rulesgroup v-if="showSpareTimeRules" :rules="spareTimeRules()" class="md-group" />
                            </div>
                        </div>
                        <div v-if="tabSelected === 'employeeFilterSection'" class="md-tab-body">
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" class="header" :text="$t('roster.main.contractPriorities')"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        ref="employeeTypeSelection"
                                        @click="toggleDropdown('employeeTypeSelection')" />
                                <labelc type="header" class="header" :text="employeeTypeSelection ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('employeeTypeSelection')" />
                                <div v-if="employeeTypeSelection">
                                    <div class="md-card-select pad-top-bottom">
                                        <checkboxgroup :value="planFullTime" :text="$t('roster.main.scheduleFulltimeEmployees')"
                                                       :id="'planFullTime'" :toggleBoolean="toggleBoolean" />
                                        <div v-if="planFullTime" class="md-card-select" style="border: 0">
                                            <labelc type="header" class="label"
                                                    :text="$t('global.ui.prio')" />
                                            <div class="slide-container">
                                                <slider :state="{min: 1, max: 3, hideMin:false, hideMax: false,
                                                    value: fullTimePriority, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                                    inputControl: true, sliderInput: (x) => {return x}}"  @callback="updateFullTimePriority" />
                                                <div class="explain">{{
                                                        fullTimePriority === 1 ? $t('roster.main.normal') : fullTimePriority === 2 ? $t('roster.main.raised') : $t('roster.main.max')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="md-card-select pad-top-bottom">
                                        <checkboxgroup :value="planPartTime" :text="$t('roster.main.schedulePartTimeEmployee')"
                                                       :id="'planPartTime'" :toggleBoolean="toggleBoolean" />
                                        <div v-if="planPartTime" class="md-card-select" style="border: 0">
                                            <labelc type="header" class="label"
                                                    :text="$t('global.ui.prio')" />
                                            <div class="slide-container">
                                                <slider :state="{min: 1, max: 3, hideMin:false, hideMax: false,
                                                    value: partTimePriority, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                                    inputControl: true, sliderInput: (x) => {return x}}" @callback="updatePartTimePriority" />
                                                <div class="explain">{{
                                                        partTimePriority === 1 ? $t('roster.main.normal') : partTimePriority === 2 ? $t('roster.main.raised') : $t('roster.main.max')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="md-card-select pad-top-bottom" style="border: none">
                                        <checkboxgroup :value="planMinTime"
                                                       :text="$t('roster.main.scheduleMiniJob')"
                                                       :id="'planMinTime'" :toggleBoolean="toggleBoolean" />
                                        <div v-if="planMinTime" class="md-card-select" style="border: 0">
                                            <labelc type="header" class="label"
                                                    :text="$t('global.ui.prio')" />
                                            <div class="slide-container">
                                                <slider v-model="minTimePriority" :state="{min: 1, max: 3, hideMin:false, hideMax: false,
                                                    value: minTimePriority, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                                    inputControl: true, sliderInput: (x) => {return x}}" @callback="updateMinTimePriority" />
                                                <div class="explain">{{
                                                        minTimePriority === 1 ? $t('roster.main.normal') : minTimePriority === 2 ? $t('roster.main.raised') : $t('roster.main.max')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" class="header" :text="$t('roster.main.employeeBasePositions')"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        ref="employeeSpotSelection"
                                        @click="toggleDropdown('employeeSpotSelection')" />
                                <labelc type="header" class="header" :text="employeeSpotSelection ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('employeeSpotSelection')" />
                                <div v-if="employeeSpotSelection" class="full" style="padding: 10px 10px 0">
                                    <buttonc type="rectangle" :label="this.$t('global.ui.selectAll')" v-on:click="toggleEmployeeSpotOptions(true)"
                                             style="width: 7em; white-space: nowrap;" />
                                    <buttonc type="rectangle" :label="this.$t('global.ui.deselectAll')" v-on:click="toggleEmployeeSpotOptions(false)"
                                             style="width: 8em; white-space: nowrap;" />
                                </div>
                                <div v-if="employeeSpotSelection" class="md-group">
                                    <datatablesimple :state="employeeSpotState" style="width: 100%;" />
                                </div>
                            </div>
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" class="header" :text="$t('roster.main.individualEmployees')"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        ref="employeeSelection"
                                        @click="toggleDropdown('employeeSelection')" />
                                <labelc type="header" class="header" :text="employeeSelection ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('employeeSelection')" />
                                <div v-if="employeeSelection" class="full" style="padding: 10px 10px 0">
                                    <buttonc type="rectangle" :label="this.$t('global.ui.selectAll')" v-on:click="toggleEmployeeOptions(true)"
                                             style="width: 7em; white-space: nowrap;" />
                                    <buttonc type="rectangle" :label="this.$t('global.ui.deselectAll')" v-on:click="toggleEmployeeOptions(false)"
                                             style="width: 8em; white-space: nowrap;" />
                                </div>
                                <div v-if="employeeSelection" class="md-group">
                                    <datatablesimple :state="employeeOptionsState" style="width: 100%;" />
                                </div>
                            </div>
                        </div>
                        <div v-if="tabSelected === 'shiftStartEndSelection'" class="md-tab-body">
                            <div class="md-card-select pad-top-bottom">
                                <labelc type="header" class="header" :text="$t('roster.main.shiftPositions')"
                                        :styleText="{marginLeft: '0'}" style="width: 60%"
                                        ref="shiftSpotSelection"
                                        @click="toggleDropdown('shiftSpotSelection')" />
                                <labelc type="header" class="header" :text="shiftSpotSelection ? '⏶' : '⏷'" style="width: auto"
                                        @click="toggleDropdown('shiftSpotSelection')" />
                                <div v-if="shiftSpotSelection" class="full" style="padding: 10px 10px 0">
                                    <buttonc type="rectangle" :label="this.$t('global.ui.selectAll')" v-on:click="toggleShiftSpotOptions(true)"
                                             style="width: 7em; white-space: nowrap;" />
                                    <buttonc type="rectangle" :label="this.$t('global.ui.deselectAll')" v-on:click="toggleShiftSpotOptions(false)"
                                             style="width: 8em; white-space: nowrap;" />
                                </div>
                                <div v-if="shiftSpotSelection" class="md-group">
                                    <datatablesimple :state="spotOptionsState" style="width: 100%;"/>
                                    
                                </div>
                            </div>

                            <div class="md-card-select pad-top-bottom">
                                <checkboxgroup :value="useShiftStartFilter" :text="$t('roster.main.shiftStartFilter')"
                                            :id="'useShiftStartFilter'" :toggleBoolean="toggleBoolean" />
                                <div v-if="useShiftStartFilter" class="md-card-select noborder">
                                    <div class="md-group border-right" style="width: auto">
                                        <labelc type="header" class="label" :text="$t('roster.main.startFrom')" />
                                        <div class="slide-container">
                                            <slider :state="{min: 0, max: 24, hideMin: true, hideMax: true,
                                                value: shiftStartFrom, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                                inputControl: true, sliderInput: (x) => {return x}}" @callback="updateShiftStartFrom" />
                                            <div class="explain">{{ shiftStartFrom + ':00' + $t('roster.main.oclock') }}</div>
                                        </div>
                                    </div>
                                    <div class="md-group" style="width: auto">
                                        <labelc type="header" class="label" :text="$t('roster.main.startUntil')" />
                                        <div class="slide-container">
                                            <slider :state="{min: 0, max: 24, hideMin: true, hideMax: true,
                                            value: shiftStartTo, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                            inputControl: true, sliderInput: (x) => {return x}}" @callback="updateShiftStartTo" />
                                            <div class="explain">{{ shiftStartTo + ':00' + $t('roster.main.oclock') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="md-card-select pad-top-bottom">
                                <checkboxgroup :value="useShiftEndFilter" :text="$t('roster.main.shiftEndFilter')"
                                            :id="'useShiftEndFilter'" :toggleBoolean="toggleBoolean" />
                                <div v-if="useShiftEndFilter" class="md-card-select noborder">
                                    <div class="md-group border-right" style="width: auto">
                                        <labelc type="header" class="label" :text="$t('roster.main.endFrom')" />
                                        <div class="slide-container">
                                            <slider :state="{min: 0, max: 24, hideMin: true, hideMax: true,
                                            value: shiftEndFrom, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                            inputControl: true, sliderInput: (x) => {return x}}" @callback="updateShiftEndFrom" />
                                            <div class="explain">{{ shiftEndFrom + ':00' + $t('roster.main.oclock') }}</div>
                                        </div>
                                    </div>
                                    <div class="md-group" style="width: auto">
                                        <labelc type="header" class="label" :text="$t('roster.main.endUntil')" />
                                        <div class="slide-container">
                                            <slider :state="{min: 0, max: 24, hideMin: true, hideMax: true,
                                            value: shiftEndTo, DisplayLabel: (val) => {return val }, step: 1, object: this,
                                            inputControl: true, sliderInput: (x) => {return x}}" @callback="updateShiftEndTo" />
                                            <div class="explain">{{ shiftEndTo + ':00' + $t('roster.main.oclock') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="md-card-select pad-top-bottom">
                                <checkboxgroup :value="useShiftDurationFilter" :text="$t('roster.main.shiftLengthFilter')"
                                            :id="'useShiftDurationFilter'" :toggleBoolean="toggleBoolean" />
                                <div v-if="useShiftDurationFilter" class="md-card-select noborder">
                                    <div class="md-group border-right" style="width: auto">
                                        <labelc type="header" class="label" :text="$t('roster.main.minLength')" />
                                        <div class="slide-container">
                                            <slider :state="{min: 0, max: 24*60, hideMin: true, hideMax: true,
                                        value: shiftDurationMin, DisplayLabel: (val) => {return (val/60.0).toFixed(2) },
                                         inputControl: true, sliderInput: (x) => {return x * 60}, step: 30, object: this}"
                                                    @callback="updateShiftDurationMin" />
                                            <div class="explain">{{ (shiftDurationMin / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="md-group" style="width: auto">
                                        <labelc type="header" class="label" :text="$t('roster.main.maxLength')" />
                                        <div class="slide-container">
                                            <slider :state="{min: 0, max: 24*60, hideMin: true, hideMax: true,
                                        value: shiftDurationMax, DisplayLabel: (val) => {return (val/60.0).toFixed(2) },
                                         inputControl: true, sliderInput: (x) => {return x * 60}, step: 30, object: this}"
                                                    @callback="updateShiftDurationMax" />
                                            <div class="explain">{{ (shiftDurationMax / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                            
                        </div>
                        <div v-if="tabSelected === 'employeePreferenceSelection'" class="md-tab-body">
                            <div  class="md-card-select pad-top-bottom" v-bind:key="prefId" v-for="(pref, prefId) in employeePreferenceRestTimeMap">
                                <checkboxgroup
                                            :value="pref.selected" :text="pref.name"
                                            :id="'pref.selected'" @toggle="toggleObject(pref, 'selected')"/>
                            </div>
                        </div>
                        <div v-if="tabSelected === 'workTimeOptionSelection'" class="md-tab-body">
                            <div class="md-card-select pad-top-bottom">
                                <checkboxgroup :value="useActualShifts" :text="$t('roster.main.usePunchTimes')" style="width: 100%"
                                            :id="'useActualShifts'" :toggleBoolean="toggleBoolean"/>
                            </div>
                            <div class="md-card-select pad-top-bottom">
                                <checkboxgroup :value="planWithHolidayBalance" :text="$t('roster.main.deductHolidayBalanceFromTarget')" style="width: 100%"
                                            :id="'planWithHolidayBalance'" :toggleBoolean="toggleBoolean"/>
                            </div>
                            <div class="md-card-select pad-top-bottom">
                                <checkboxgroup :value="planWithPreviousMonth" :text="$t('roster.main.workTimeBalanceFromPreviousMonth')" style="width: 100%"
                                            :id="'planWithPreviousMonth'" :toggleBoolean="toggleBoolean"/>
                            </div>
                        </div>
                    </div>
                </section>
                <section v-if="state === 0" style="overflow: hidden; padding-top: 15%;">
                    <div v-if="!error" class="center">
                        <p class="loading-text">{{ $t('roster.main.loadAndPrepareData') }}</p>
                    </div>
                    <div v-if="!error" class="center">
                        <i class="loading-text fas fa-spinner"></i>
                    </div>
                    <div v-else>
                        <p class="loading-text">{{ errorMsg }}</p>
                    </div>
                </section>
            </div>

            <div v-if="error && state !== 0">
                    {{ errorMsg }}
            </div>
        </div>
        <div class="footer">
            <div class="align-left" v-if="state > 1 && detailedMode">
                <buttonc type="rectangle yellow" :label="$t('roster.main.back')" @click="abortStage()" style="width: 110px;"/>
            </div>
            <div class="align-left" v-if="state === 5 && !detailedMode">
                <buttonc type="rectangle yellow" :label="$t('roster.main.detailMode')" @click="switchToDetailMode()"
                         style="width: 110px;"/>
            </div>
            <div class="align-right" v-if="state > 0">
                <buttonc type="rectangle green" :label="state < 5 ? $t('global.ui.next') : $t('roster.main.startPlanning')"
                         @click="confirmStage()" style="width: 110px;" :disabled="sendingRequest"/>
            </div>
            <div class="align-right" v-if="state === 0">
                <buttonc v-if="error" type="rectangle" :label="$t('global.ui.cancel')" @click="abortStage()"
                         style="width: 110px;"/>
            </div>
        </div>
    </div>
</template>

<script>
import VueEventBus from '../../vue-event-bus';
import slider from '../uicomponents/slider.vue';
import {mapGetters} from 'vuex';
import dropdownsearch from "@/components/uicomponents/dropdownsearch.vue";
import Rulesgroup from "@/components/rostercontext/RulesGroup.vue";
import Checkboxgroup from "@/components/uicomponents/generic/checkboxgroup.vue";
import Availabilitytable from "@/components/rostercontext/AvailabilityTable.vue";
import Shifttable from "@/components/rostercontext/ShiftTable.vue";

export default {
    name: 'rosterrequestwizard',
    components: {
        Shifttable,
        Availabilitytable,
        Checkboxgroup,
        Rulesgroup,
        dropdownsearch,
        slider,
    },
    data() {
        return {
            tabSelected: 'configSelection',
            showEmployeeTypeRules: false,
            showDefaultRules: false,
            showSpareTimeRules: false,
            employeeTypeSelection: false,
            employeeSpotSelection: false,
            employeeSelection: false,
            shiftSpotSelection: false,
            showEmployeeOptions: [],
            ruleProfileState: null,
            planFromState: null,
            planToState: null,
            uiData: {},
            employeeAvailabilityStateMap: {},
            employeeAvailabilityTypeMap: {},
            bunitMap: {},
            //#######
            spotOptions: [],
            selectedSpots: [],
            spotMap: {},
            employeeSpotOptions: [],
            selectedEmployeeSpots: [],
            selectedShiftSpots: [],
            //#######
            holidayMap: {},
            //#######
            shiftOptions: [],
            impossibleShiftOptions: [],
            actualShiftOptions: [],
            useActualShifts: true,
            shiftMap: {},
            actualShiftMap: {},
            employeeDateActualShiftMap: {},
            actualBreakMap: {},
            //#######
            skillMap: {},
            shiftSkillMap: {},
            //#######
            employeeOptions: [],
            //employeeFields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key: "checked", label: "Ausgewählt"}],
            employeeFields: [{
                key: "name",
                label: this.$t('pages.employeeData.name'),
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                sortable: true
            }, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: this.$t('roster.main.selected')}],
            selectedEmployeeOptions: [],
            employeeMap: {},
            //#######
            employeeAvailabilityOptions: [],
            employeeAvailabilityMap: {},
            //#######
            employeePreferenceOptions: [],
            employeePreferenceFields: [{
                key: "spot",
                label: this.$tc('shift.main.position'),
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                sortable: true
            }, {key: "employee", label: this.$tc('global.general.employee'), thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},
                {key: "from", label: this.$t('global.general.from'), thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {
                    key: "to",
                    label: this.$t('global.general.to'),
                    thClass: 'documentsTh',
                    tdClass: 'documentsTd',
                    sortable: true
                }, {key: "stateLabel", label: this.$t('global.general.status'), thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},
                {
                    key: "typeLabel",
                    label: this.$tc('global.general.type'),
                    thClass: 'documentsTh',
                    tdClass: 'documentsTd',
                    sortable: true
                }, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: this.$t('roster.main.selected')}],
            fullWeekPlanFrom: null,
            fullWeekPlanTo: null,
            employeePreferenceMap: {},
            //#######
            employeeContractMap: {},
            previousMonthWorkBalanceMap: {},
            //#######
            employeeSkillMap: {},
            employeeTypeMap: {},
            employeeWeeklyParametersMap: {},
            employeeTypeTemplateMap: {},
            employeeEmployeeTypeMap: {},
            employeeEmployeeWeeklyParametersMap: {},
            employeeRulesMap: {},
            spotPayload: {ids: []},
            employeePayload: {ids: []},
            useShiftStartFilter: false,
            shiftStartFrom: 0,
            shiftStartTo: 24,
            useShiftEndFilter: false,
            shiftEndFrom: 0,
            shiftEndTo: 24,
            useShiftDurationFilter: false,
            shiftDurationMin: 0,
            shiftDurationMax: 24 * 60,
            state: 0,
            detailedMode: false,
            planWithHolidayBalance: false,
            planWithPreviousMonth: true,
            monthTimeRegularPercentage: 100,
            ruleProfileMap: {},
            ruleProfiles: [],
            ruleProfile: 1,
            planDates: [],
            planFrom: null,
            planTo: null,
            hp: false,
            applyPregnancyRules: true,
            applyYouthRules: true,
            rosterConfiguration: {
                dayIndexStart: 1,
                dayIndexEnd: 1,
                month: 1,
                year: 2019,
                additionalWeeks: 0,
                additionalWorkDays: [],
                //rules that should always be enabled
                rules: {"1": 1, "5": 1, "6": 1, "7": 1, "8": 1, "19": 1, "20": 1},
                rulesSoftScoreLevels: {}

            },
            enabledRulesMap: {},
            planRunTime: 30,
            fullTimePriority: 3,
            planFullTime: true,
            partTimePriority: 3,
            planPartTime: true,
            minTimePriority: 3,
            planMinTime: true,
            sendingRequest: false,
            error: false,
            errorMsg: "",
            styleLabelLeft: {
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'left',
                background: '',
                height: 'calc(100% - 10px)'
            },
        }
    },
    created: function () {
        VueEventBus.$on("open-autoscheduler-wizard", this.show);

    },
    beforeDestroy() {
        VueEventBus.$off("open-autoscheduler-wizard", this.show);
    },
    mounted() {
        this.show();
        this.$parent.$el.querySelector('.container-body').addEventListener('scroll', this.FooterUpdate);
    },
    computed: {
        ...mapGetters(['storeId', 'isSuperUser', 'storeSettings', 'rosterFromTo']),
        tabs() {
            return [
                {label: this.$t('store.settings.title'), view: 'configSelection', margin: true},
                {label: this.$t('roster.comp.rules'), view: 'ruleSelection', margin: true},
                {label: this.$t('roster.comp.employeeFilter'), view: 'employeeFilterSection', margin: true},
                {label: this.$t('roster.comp.shiftFilter'), view: 'shiftStartEndSelection', margin: true},
                {label: this.$t('roster.comp.restTimeAbsence'), view: 'employeePreferenceSelection', margin: true},
                {label: this.$t('roster.comp.workTimeOptions'), view: 'workTimeOptionSelection', margin: true},
            ];
        },
        selectedTab() {
            return this.tabs.filter(t => t.view === this.tabSelected)[0];
        },
        spotOptionsState() {
            let view = this;

            let state = {
                headerMap: [],
            };

            let columns = {
                active: this.$t('global.general.active'),
                name: this.$t('pages.employeeData.name'),
                bunitName: this.$t('roster.main.unit')
            };

            let data = Object.values(this.spotOptions);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'name', view.styleLabelLeft);
            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'bunitName', view.styleLabelLeft);
            state.headerMap.bunitName.sort = true;

            // Actions
            state.headerMap.active.componentTypeRow = 'checkbox';
            state.headerMap.active.componentStateBuilders = [(data) => {
                return {
                    componentType: 'checkbox',
                    disabled: false,
                    value: data.checked,
                    toggleCheck: true,
                    customEvents: {
                        Update: () => {
                            data.checked = !data.checked;
                        }
                    },
                }

            }];

            let entries = Object.entries(state.headerMap);

            let mainColumns = ['name', 'bunitName'];
            let mainColumnWidth = 42;
            let actionColumns = ['active'];
            let actionColumnWidth = 6;
            for (let x in entries) {
                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '12px', top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.alwaysUnfold = false;
            return state;
        },
        employeeSpotState() {
            let view = this;

            let state = {
                headerMap: [],
            };

            let columns = {
                active: this.$t('global.general.active'),
                name: this.$t('pages.employeeData.name'),
                bunitName: this.$t('roster.main.unit')
            };

            let data = Object.values(this.employeeSpotOptions);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'name', view.styleLabelLeft);
            state.headerMap.name.align = 'left';
            state.headerMap.name.alignHeaderLabel = 'left';

            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'bunitName', view.styleLabelLeft);
            state.headerMap.bunitName.align = 'left';
            state.headerMap.bunitName.alignHeaderLabel = 'left';
            state.headerMap.bunitName.sort = true;

            // Actions
            state.headerMap.active.componentTypeRow = 'checkbox';
            state.headerMap.active.componentStateBuilders = [(data) => {
                return {
                    componentType: 'checkbox',
                    disabled: false,
                    value: data.checked,
                    toggleCheck: true,
                    customEvents: {
                        Update: () => {
                            data.checked = !data.checked;
                        }
                    }
                }

            }];

            let entries = Object.entries(state.headerMap);

            let mainColumns = ['name', 'bunitName'];
            let mainColumnWidth = 47;
            let actionColumns = ['active'];
            let actionColumnWidth = 6;
            for (let x in entries) {
                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '12px', top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.alwaysUnfold = false;
            return state;
        },
        employeeOptionsState() {
            let view = this;

            let state = {
                headerMap: [],
            };

            let columns = {
                active: this.$t('global.general.active'),
                name: this.$t('pages.employeeData.name'),
            };

            let data = Object.values(this.employeeOptions);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'name', view.styleLabelLeft);
            state.headerMap.name.sort = true;
            state.headerMap.name.align = 'left';
            state.headerMap.name.alignHeaderLabel = 'left';

            // Actions
            state.headerMap.active.componentTypeRow = 'checkbox';
            state.headerMap.active.componentStateBuilders = [(data) => {
                return {
                    componentType: 'checkbox',
                    disabled: false,
                    value: data.checked,
                    toggleCheck: true,
                    customEvents: {
                        Update: () => {
                            data.checked = !data.checked;
                        }
                    }
                }

            }];

            let entries = Object.entries(state.headerMap);

            let mainColumns = ['name'];
            let mainColumnWidth = 94;
            let actionColumns = ['active'];
            let actionColumnWidth = 6;
            for (let x in entries) {
                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '12px', top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.alwaysUnfold = false;
            return state;
        },
        contractTypeMap() {
            let map = {};
            if (this.planFullTime) {
                map['1'] = Math.max(1, 4 - this.fullTimePriority);
            }
            if (this.planPartTime) {
                map['2'] = Math.max(1, 4 - this.partTimePriority);
            }
            if (this.planMinTime) {
                map['3'] = Math.max(1, 4 - this.minTimePriority);
            }
            return map;
        },
        asLicenseLabels() {
            let labels = {
                asLicense: "Keine Lizenz vorhanden",
                hpLicense: "Keine Lizenz vohanden"
            }
            if (this.storeSettings.asLicExpiry) {
                labels.asLicense = this.$helpers.getMomentFromStringTZ(this.storeSettings.asLicExpiry).format("DD.MM.YYYY");
            }
            return labels;
        },
        rosterFromTo() {
            if (this.$store.state.loggedIn) {
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }
        },
        currentMonthFrom() {
            let from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            return from;
        },
        currentMonthTo() {
            if (this.currentMonthFrom) {
                let to = this.currentMonthFrom.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
        employeeAvailabilityEmployeeAccordionEntries() {
            let accordionEntries = {}
            let view = this;
            this.employeeAvailabilityOptions.forEach(option => {

                if (view.employeeMap[option.value.employeeId]) {
                    if (!accordionEntries[option.value.employeeId]) {
                        accordionEntries[option.value.employeeId] = [];
                    }
                    accordionEntries[option.value.employeeId].push(option);
                }

            })

            return Object.keys(accordionEntries).map(key => {
                return {
                    id: key,
                    label: view.employeeMap[key].firstName + ' ' + view.employeeMap[key].lastName,
                    entries: accordionEntries[key],
                    show: accordionEntries[key].filter(e => e.show === true).length > 0,
                };
            });

        },
        employeePreferenceEmployeeAccordionEntries() {
            let accordionEntries = {}
            let view = this;
            this.employeePreferenceOptions.forEach(option => {

                if (view.employeeMap[option.value.employeeId]) {
                    if (!accordionEntries[option.value.employeeId]) {
                        accordionEntries[option.value.employeeId] = [];
                    }
                    accordionEntries[option.value.employeeId].push(option);
                }

            })

            return Object.keys(accordionEntries).map(key => {
                return {
                    id: key,
                    label: view.employeeMap[key].firstName + ' ' + view.employeeMap[key].lastName,
                    entries: accordionEntries[key],
                    show: accordionEntries[key].filter(e => e.show === true).length > 0,
                };
            });

        },
        planshiftWeekAccordionEntries() {
            let accordionEntries = {}
            this.shiftOptions.forEach(option => {
                let weekId = 'KW-' + option.week + '-' + option.year;
                if (!accordionEntries[weekId]) {
                    accordionEntries[weekId] = [];
                }
                accordionEntries[weekId].push(option);
            })

            return Object.keys(accordionEntries).map(key => {
                return {
                    id: key,
                    entries: accordionEntries[key],
                    show: accordionEntries[key].filter(e => e.show === true).length > 0,
                };
            });

        },
        impossiblePlanshiftWeekAccordionEntries() {
            let accordionEntries = {}
            this.impossibleShiftOptions.forEach(option => {
                let weekId = 'KW-' + option.week + '-' + option.year;
                if (!accordionEntries[weekId]) {
                    accordionEntries[weekId] = [];
                }
                accordionEntries[weekId].push(option);
            })

            return Object.keys(accordionEntries).map(key => {
                return {id: key, entries: accordionEntries[key],
                    show: accordionEntries[key].filter(e => e.show === true).length > 0,};
            });

        },
        actualShiftWeekAccordionEntries() {
            let accordionEntries = {}
            this.actualShiftOptions.forEach(option => {
                let weekId = 'KW-' + option.week + '-' + option.year;
                if (!accordionEntries[weekId]) {
                    accordionEntries[weekId] = [];
                }
                accordionEntries[weekId].push(option);
            })

            return Object.keys(accordionEntries).map(key => {
                return {id: key, entries: accordionEntries[key],
                    show: accordionEntries[key].filter(e => e.show === true).length > 0,};
            });
        },
        selectedShiftIds() {
            return this.planshiftWeekAccordionEntries.map(e => e.entries).reduce((a, b) => a.concat(b), []).filter(e => e.checked).map(e => e.id);
        },
        noPlanShiftIds() {
            return this.planshiftWeekAccordionEntries.map(e => e.entries).reduce((a, b) => a.concat(b), []).filter(e => e.noplan).map(e => e.id);
        },
        employeeInfos() {
            let infos = {};
            this.employeeOptions.forEach(option => {
                let info = {
                    id: option.id,
                    name: option.name,
                    typeId: option.typeId,
                    ruleId: option.ruleId,
                    selected: true
                };
                if (this.employeeEmployeeTypeMap[option.id]) {
                    info.typeTemplate = this.employeeTypeTemplateMap[this.employeeEmployeeTypeMap[option.id].templateId];
                    info.type = this.employeeEmployeeTypeMap[option.id];
                    info.show = option.show === undefined ? false : option.show;
                }
                infos[info.id] = info;
            });
            return infos;
        },
        employeePreferenceRestTimeMap() {
            let map = {};
            let pref = {id: 1, name: this.$t('workBalance.summary.vacation'), selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(1)};
            map[pref.id] = pref;
            pref = {id: 2, name: this.$t('roster.main.sickness'), selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(2)};
            map[pref.id] = pref;
            pref = {
                id: 3,
                name: this.$t('workBalance.payroll.holidayCompensation'),
                selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(3)
            };
            map[pref.id] = pref;
            pref = {id: 6, name: this.$t('workBalance.summary.nursingLeave'), selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(6)};
            map[pref.id] = pref;
            pref = {id: 7, name: this.$t('workBalance.summary.trainee'), selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(7)};
            map[pref.id] = pref;
            pref = {id: 8, name: this.$t('workBalance.summary.sickPay'), selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(8)};
            map[pref.id] = pref;
            pref = {id: 4, name: this.$t('roster.main.other'), selected: this.storeSettings.lawCheckRestTimePrefTypes.includes(4)};
            map[pref.id] = pref;
            return map;
        }

    },

    watch: {
        useActualShifts(newVal, oldVal) {
            this.calculateShiftOptions();
        },
        ruleProfiles(newVal) {
            this.ruleProfileState = {
                selectMultiple: false, selectFirst: true, styleLight: true,
                placeholder: this.$t('roster.main.selectRule'),
                items: Object.values(newVal)
                    .map(s => ({label: s.labelDe, value: s.id, selected: false})),
            }
        },
        planDates(newVal) {

            let datesFrom = Object.values(newVal).map(s => ({label: s.label, value: s.value, selected: s.value == this.planFrom}));
            let selectedFromItem = datesFrom.find(s => s.selected);
            this.planFromState = {
                selectMultiple: false, selectFirst: false, selectedItem: selectedFromItem, styleLight: true,
                placeholder: this.$t('roster.main.selectFrom'), items: datesFrom,
            }

            let datesTo = Object.values(newVal).map(s => ({label: s.label, value: s.value, selected: s.value == this.planTo}));
            let selectedToItem = datesTo.find(s => s.selected);
            this.planToState = {
                selectMultiple: false, selectFirst: false, selectedItem: selectedToItem, styleLight: true,
                placeholder: this.$t('roster.main.selectUntil'), items: datesTo,
            }
        },
    },
    // methods that implement data logic.
    methods: {
        UpdateRosterRequestTab(tab) {
            this.tabSelected = this.tabSelected !== tab.view ? tab.view : '';
        },
        updateRuleProfile(item) {
            this.ruleProfile = item.value;
        },
        updatePlanFrom(item) {
            this.planFrom = item.value;
        },
        updatePlanTo(item) {
            this.planTo = item.value;
        },
        toggleBoolean(val, field) {
            this[field] = !val;
        },
        toggleObject(obj, field) {
            obj[field] = !obj[field];
        },
        toggleSimpleEntries(entry, val, id) {
            this.$nextTick(() => {
                let view = this;
                view[val].filter(ei => ei.id === entry).forEach(ei => {
                    if (ei.show === undefined) {
                        view.$set(ei, 'show', true);
                    } else {
                        view.$set(ei, 'show', !ei.show);
                    }
                })
                if(view.$refs[id][0]){
                    view.$refs[id][0].$el.scrollIntoView({behavior: 'instant'})
                }
                
            });
        },
        toggleAccordionEntries(entry, val, id) {
            this.$nextTick(() => {
                let view = this;
                entry.entries.forEach(e => {
                    view[val].filter(avail => avail.id === e.id).forEach(avail => {
                        if (avail.show === undefined) {
                            view.$set(avail, 'show', true);
                        } else {
                            view.$set(avail, 'show', !avail.show);
                        }
                    })
                })

                if (id === undefined) {
                    view.$refs.comp[0].$el.scrollIntoView({behavior: 'instant'})
                } else {
                    view.$refs[id][0].$el.scrollIntoView({behavior: 'instant'})
                }
            });
        },
        toggleDropdown(val) {
            this.$nextTick(() => {
                let view = this;
                view[val] = !view[val];
                view.$refs[val].$el.scrollIntoView({behavior: 'instant'})
            });
        },
        toggleEmployeeOptions(val) {
            this.employeeOptions.forEach(o => o.checked = val);
        },
        toggleEmployeeSpotOptions(val) {
            this.employeeSpotOptions.forEach(o => o.checked = val);
        },
        toggleShiftSpotOptions(val) {
            this.spotOptions.forEach(o => o.checked = val);
        },
        FooterUpdate($event) {
            $(this.$parent.$el).find('.footer').css('bottom', (-1 * $(this.$parent.$el).find('.container-body').scrollTop()) - 0 + 'px');
        },
        confirmStage($event) {
            //$event.preventDefault();
            if (this.state == 1) {
                this.confirmStage1();
            } else if (this.state == 2) {
                this.confirmStage2();
            } else if (this.state == 3) {
                this.confirmStage3();
            } else if (this.state == 4) {
                this.confirmStage4();
            } else if (this.state == 5) {
                this.confirmStage5();
            }
        },
        abortStage: function ($event) {
            //$event.preventDefault();
            if (this.state <= 1) {
                if (this.$parent && this.$parent.Close) this.$parent.Close();
                //this.hideModal('modal-rosterrequestwizard');
            } else {
                this.state = this.state - 1;
            }
        },
        show() {
            let view = this;
            view.error = false;
            this.state = 0;
            this.detailedMode = false;
            this.planWithHolidayBalance = false;
            this.planWithPreviousMonth = true;
            this.monthTimeRegularPercentage = 100;
            //this.$refs['modal-rosterrequestwizard'].show();
            this.prepareStage1()
                .then(res => {
                    return view.confirmStage1();
                }).then(res => {
                return view.confirmStage2();
            }).then(res => {
                return view.confirmStage3();
            }).then(res => {
                return view.confirmStage4();
            }).then(res => {
                view.state = 5;
            }).catch(error => {
                view.error = true;
                view.errorMsg = error;
            });

        },
        setEnabledRulesMap() {
            this.enabledRulesMap = {
                //always active
                "1": {
                    id: 1,
                    type: "default",
                    name: this.$t('roster.main.baseRules'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.baseRulesHelp')
                },
                "5": {
                    id: 5,
                    type: "default",
                    name: this.$t('roster.main.maxWorkTimeDay'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.maxWorkTimeDayHelp')
                },
                "6": {
                    id: 6,
                    type: "default",
                    name: this.$t('roster.main.maxWorkTimeWeek'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.maxWorkTimeWeekHelp')
                },
                "7": {
                    id: 7,
                    type: "default",
                    name: this.$t('roster.main.maxWorkTimeMonth'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.maxWorkTimeMonthHelp')
                },
                "8": {
                    id: 8,
                    type: "default",
                    name: this.$t('roster.main.minFreeTimeWeek'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.minFreeTimeWeekHelp')
                },
                "19": {
                    id: 19,
                    type: "default",
                    name: this.$t('roster.main.targetMonthFairness'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.targetMonthFairnessHelp')
                },
                "20": {
                    id: 20,
                    type: "default",
                    name: this.$t('roster.main.underageSundayRule'),
                    disabled: true,
                    checked: true,
                    description: this.$t('roster.main.underageSundayRuleHelp')
                },
                //active if enabled in employeerules
                "9": {
                    id: 9,
                    type: "spareTime",
                    name: this.$t('store.templates.wishes'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.spareTimeHelp')
                },
                "10": {
                    id: 10,
                    type: "spareTime",
                    name: this.$t('store.templates.dislikes'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.dislikeHelp')
                },
                "12": {
                    id: 12,
                    type: "spareTime",
                    name: this.$tc('store.templates.weekends', 2),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.fairWeekendHelp')
                },
                "13": {
                    id: 13,
                    type: "spareTime",
                    name: this.$tc('store.templates.weekendDays', 2),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.fairWeekendDayHelp')
                },
                "15": {
                    id: 15,
                    type: "spareTime",
                    name: this.$t('roster.main.employeeSkills'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.employeeSkillsHelp')
                },
                "16": {
                    id: 16,
                    type: "spareTime",
                    name: this.$t('roster.main.fairnessConditions'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.fairnessConditionsHelp')
                },
                "24": {
                    id: 24,
                    type: "spareTime",
                    name: this.$t('store.templates.biorhythm'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.bioRhythmHelp')
                },

                //active if enabled in employeetype
                "2": {
                    id: 2,
                    type: "employeeType",
                    name: this.$t('roster.main.maxConsecutiveDays'),
                    disabled: false,
                    checked: true,
                    description: this.$t('pages.employeeContract.planningEmployeeType')
                },
                "3": {
                    id: 3,
                    type: "employeeType",
                    name: this.$t('roster.main.maxOvertimeMonth'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.maxOvertimeMonthHelp')
                },
                "4": {
                    id: 4,
                    type: "employeeType",
                    name: this.$t('roster.main.maxWorkDaysWeek'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.maxWorkDaysWeekHelp')
                },
                "29": {
                    id: 29,
                    type: "employeeType",
                    name: this.$t('roster.main.averageWeekTimeFairness'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.averageWeekTimeFairnessHelp')
                },
                "30": {
                    id: 30,
                    type: "employeeType",
                    name: this.$t('roster.main.keepAverageWeekTime'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.keepAverageWeekTimeHelp')
                },
                "31": {
                    id: 31,
                    type: "employeeType",
                    name: this.$t('roster.main.minFreeTimeExtension'),
                    disabled: false,
                    checked: true,
                    description: this.$t('roster.main.minFreeTimeExtensionHelp')
                },

                //additional rules
                "27": {
                    id: 27,
                    type: "bonus",
                    name: this.$t('roster.main.targetWorkTimeFairness'),
                    disabled: false,
                    checked: false,
                    description: this.$t('roster.main.targetWorkTimeFairnessHelp')
                },
                "17": {
                    id: 17,
                    type: "bonus",
                    name: this.$t('roster.main.targetWorkTimeWeekFairness'),
                    disabled: false,
                    checked: false,
                    description: this.$t('roster.main.targetWorkTimeWeekFairnessHelp')
                },
                "18": {
                    id: 18,
                    type: "bonus",
                    name: this.$t('roster.main.targetWorkDaysWeekFairness'),
                    disabled: false,
                    checked: false,
                    description: this.$t('roster.main.targetWorkDaysWeekFairnessHelp')
                },


            };
        },
        defaultRules() {
            return Object.values(this.enabledRulesMap).filter(i => i.type === "default");
        },
        spareTimeRules() {
            return Object.values(this.enabledRulesMap).filter(i => i.type === "spareTime");
        },
        employeeTypeRules() {
            return Object.values(this.enabledRulesMap).filter(i => i.type === "employeeType");
        },
        bonusRules() {
            return Object.values(this.enabledRulesMap).filter(i => i.type === "bonus");
        },
        switchToDetailMode() {
            this.detailedMode = true;
            this.state = 1;
        },
        hideModal(ref) {

            if (this.$parent && this.$parent.Close) this.$parent.Close();
            //this.$refs[ref].hide();
        },
        updateEmployeeInfoMonthTimeRegular(value, employee) {
            let monthTimeRegular = Math.round(value / 60 * 4.325) * 60;
            employee.type.monthTimeRegular = monthTimeRegular;
            employee.type.weekTimeRegular = value;
        },
        updateEmployeeInfoMonthTimeMaxAdjustment(value, employee) {
            employee.type.monthTimeMaxAdjustment = value;
        },
        updateEmployeeInfoWeekTimeMax(value, employee) {
            employee.type.weekTimeMax = value;
        },
        updateEmployeeInfoWeekWorkDaysRegular(value, employee) {
            employee.type.weekWorkDaysRegular = value;
        },
        updateEmployeeInfoWeekSpareDaysMin(value, employee) {
            employee.type.weekSpareDaysMin = value;
            let weekSpareTimeMin = (Math.floor(employee.typeTemplate.weekSpareTimeMinMin / 60) - (employee.typeTemplate.weekSpareDaysMinMin * 24)) * 60 + 24 * 60 * employee.type.weekSpareDaysMin;
            employee.type.weekSpareTimeMin = weekSpareTimeMin;
        },
        updateEmployeeInfoDayTimeRegular(value, employee) {
            employee.type.dayTimeRegular = value;
        },
        updateEmployeeInfoDayTimeMax(value, employee) {
            employee.type.dayTimeMax = value;
        },
        updateEmployeeInfoRestTime(value, employee) {
            employee.type.restTime = value;
        },
        updateEmployeeInfoShiftTimeBetweenMin(value, employee) {
            employee.type.shiftBetweenTimeMin = value;
        },
        updateEmployeeInfoShiftTimeBetweenMax(value, employee) {
            employee.type.shiftBetweenTimeMax = value;
        },
        updateEmployeeInfoDaysConsecutiveMax(value, employee) {
            employee.type.daysConsecutiveMax = value;
        },
        updateEmployeeInfoMonthOvertimeMax(value, employee) {
            employee.type.monthOvertimeMax = value;
        },
        updateEmployeeInfoWeekWorkDaysMax(value, employee) {
            employee.type.weekWorkDaysMax = value;
        },
        updatePlanRunTime(value, $event) {
            this.planRunTime = value;
        },
        updateMonthTimeRegularPercentage(value, $event) {
            this.monthTimeRegularPercentage = value;
        },
        updateFullTimePriority(value, $event) {
            this.fullTimePriority = value;
        },
        updatePartTimePriority(value, $event) {
            this.partTimePriority = value;
        },
        updateMinTimePriority(value, $event) {
            this.minTimePriority = value;
        },
        updateShiftStartFrom(value, $event) {
            this.shiftStartFrom = value;
        },
        updateShiftStartTo(value, $event) {
            this.shiftStartTo = value;
        },
        updateShiftEndFrom(value, $event) {
            this.shiftEndFrom = value;
        },
        updateShiftEndTo(value, $event) {
            this.shiftEndTo = value;
        },
        updateShiftDurationMin(value, $event) {
            this.shiftDurationMin = value;
        },
        updateShiftDurationMax(value, $event) {
            this.shiftDurationMax = value;
        },

        prepareStage1: function () {

            let view = this;
            return this.$helpers.GetUiDataMap().then(uiData => {
                view.updateUIData(uiData);
                return view.loadBusinessUnits();
            }).then(map => {
                view.bunitMap = map;
                return view.loadSkills();
            }).then(map => {
                view.skillMap = map;
                return view.loadHolidays();

            }).then(map => {
                view.holidayMap = map;
                return view.loadSpots();
            }).then(map => {
                view.spotMap = map;
                let spotOptions = [];
                let employeeSpotOptions = [];
                Object.values(view.spotMap)
                    .forEach(spot => {
                        let tOption = {
                            id: spot.id,
                            name: spot.name,
                            bunitName: view.bunitMap[spot.unitId].name,
                            value: spot,
                            checked: true
                        }
                        spotOptions.push(tOption);
                        let sOption = {
                            id: spot.id,
                            name: spot.name,
                            bunitName: view.bunitMap[spot.unitId].name,
                            value: spot,
                            checked: true
                        }
                        employeeSpotOptions.push(sOption);
                    });

                view.spotOptions = spotOptions;
                view.spotOptions.sort((a, b) => a.name.localeCompare(b.name));
                view.employeeSpotOptions = employeeSpotOptions;
                view.employeeSpotOptions.sort((a, b) => a.name.localeCompare(b.name));

                return view.loadEmployeeTypeTemplates();
            }).then(map => {
                view.employeeTypeTemplateMap = map;
                if (view.detailedMode) {
                    view.state = 1;
                }
                return new Promise((resolve, reject) => {
                    resolve();
                });
            }).catch(error => {
                view.error = true;
                if (error.msg != null) {
                    view.errorMsg = error.msg;
                } else {
                    console.log(error);
                    view.errorMsg = this.$t('roster.main.loadStage1Error')
                }
                return new Promise((resolve, reject) => {
                    reject(this.$t('global.notifications.dataLoadingError'));
                })
            })

        },
        confirmStage1: function () {
            let selectedMonth = this.currentMonthFrom.month();
            let selectedYear = this.currentMonthFrom.year();

            let startDate = this.$helpers.getCurrentMonthMomentTZ().month(selectedMonth).year(selectedYear).startOf('month');
            let endDate = startDate.clone().endOf('month');

            if (this.spotOptions.filter(i => i.checked === true).length < 1) {
                this.error = true;
                this.errorMsg = this.$t('roster.main.selectBusinessUnitPlease')
                return new Promise((resolve, reject) => {
                    reject(this.$t('roster.main.nothingToPlan'));
                });
            } else {

                // DO NOT TOUCH DATE + WORKDAY INDEX CALCULATION UNLESS YOU KNOW WHAT YOU ARE DOING
                this.rosterConfiguration.dayIndexStart = startDate.date();
                this.rosterConfiguration.dayIndexEnd = endDate.date();
                this.rosterConfiguration.month = startDate.month() + 1;
                this.rosterConfiguration.year = startDate.year();

                this.fullWeekPlanFrom = startDate.clone().startOf('isoWeek');

                if (startDate.format() == this.fullWeekPlanFrom.format()) {
                    this.fullWeekPlanFrom.add(-1, 'weeks');
                }
                this.fullWeekPlanTo = endDate.clone().endOf('isoWeek').add(1, 'weeks').startOf('isoWeek');

                let tempWeekStart = this.fullWeekPlanFrom.clone();
                let targetIndexDelta = this.calculateWorkDayIndex(startDate) - 1;
                let indexDelta = this.calculateWorkDayIndex(tempWeekStart) - 1;

                while (indexDelta != targetIndexDelta) {
                    this.rosterConfiguration.additionalWorkDays.push(indexDelta);
                    tempWeekStart = tempWeekStart.add(1, 'days');
                    indexDelta = this.calculateWorkDayIndex(tempWeekStart) - 1;
                }

                let tempWeekEnd = this.fullWeekPlanTo.clone();
                targetIndexDelta = this.calculateWorkDayIndex(endDate) - 1;
                indexDelta = this.calculateWorkDayIndex(tempWeekEnd) - 1;

                while (indexDelta !== targetIndexDelta) {
                    this.rosterConfiguration.additionalWorkDays.push(indexDelta);
                    tempWeekEnd = tempWeekEnd.subtract(1, 'days');
                    indexDelta = this.calculateWorkDayIndex(tempWeekEnd) - 1;
                }

                this.selectedSpots = [];
                let spotPayload = {ids: []};
                let spotSkillPayload = {ids: []};
                for (let i = 0; i < this.spotOptions.length; i++) {
                    if (this.spotOptions[i].checked) {
                        this.selectedSpots.push(this.spotOptions[i].id);
                        spotPayload.ids.push(this.spotOptions[i].id);
                        spotSkillPayload.ids.push(this.spotMap[this.spotOptions[i].id].requiredSkill);
                    }

                }
                this.spotPayload = spotPayload;
                this.error = false;
                return this.prepareStage2(spotSkillPayload);
            }
        },
        prepareStage2: function (payload) {
            let view = this;
            let rulepayload = {ids: []};
            let typepayload = {ids: []};
            let employeePayload = {ids: []};
            return this.loadEmployeesAnySkill(payload)
                .then(response => {

                    let employeeMap = {}
                    let employeeOptions = [];


                    for (let i = 0; i < response.data.length; i++) {

                        if (response.data[i].typeId != null && response.data[i].ruleId != null) {

                            let tOption = {
                                id: response.data[i].id,
                                name: response.data[i].lastName + " " + response.data[i].firstName,
                                typeId: response.data[i].typeId,
                                ruleId: response.data[i].ruleId,
                                checked: true
                            }
                            employeeOptions.push(tOption);
                            employeePayload.ids.push(response.data[i].id);

                            employeeMap[response.data[i].id] = response.data[i];
                            if (!typepayload.ids.includes(response.data[i].typeId)) {
                                typepayload.ids.push(response.data[i].typeId);
                            }
                            if (!rulepayload.ids.includes(response.data[i].ruleId)) {
                                rulepayload.ids.push(response.data[i].ruleId);
                            }
                        }

                    }
                    employeeOptions.sort((a, b) => a.name.localeCompare(b.name));

                    view.employeeOptions = employeeOptions.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    });
                    view.employeeMap = employeeMap;
                    view.employeePayload = employeePayload;
                    view.error = false;

                    return this.loadEmployeeSkillsAnyEmployee(view.employeePayload);

                }).then(response => {

                    let employeeSkillMap = {};
                    for (let i = 0; i < response.data.length; i++) {
                        let skillId = response.data[i].skillId;
                        let employeeId = response.data[i].employeeId;
                        let value = response.data[i].value;
                        if (!employeeSkillMap[employeeId]) {
                            employeeSkillMap[employeeId] = {};

                        }
                        employeeSkillMap[employeeId][skillId] = {skillId: skillId, value: value};
                    }
                    view.employeeSkillMap = employeeSkillMap;
                    //Remember: employee skill id might not be in skillMap because skill is not required => skip when creating request payload
                    return this.loadEmployeeRulesAny(rulepayload);
                }).then(response => {

                    let employeeRulesMap = {};
                    for (let i = 0; i < response.data.length; i++) {
                        employeeRulesMap[response.data[i].id] = response.data[i];
                    }
                    view.employeeRulesMap = employeeRulesMap;

                    return this.loadEmployeeTypeAny(typepayload)
                }).then(map => {


                    view.employeeTypeMap = map;
                    let employeeEmployeeTypeMap = {};
                    employeePayload.ids.forEach(id => {
                        let employee = view.employeeMap[id];
                        if (employee) {
                            let employeeType = view.employeeTypeMap[employee.typeId];
                            if (employeeType) {
                                employeeEmployeeTypeMap[id] = Object.assign({}, employeeType);
                            }
                        }
                    });
                    view.employeeEmployeeTypeMap = employeeEmployeeTypeMap;
                    return view.loadEmployeeWeeklyParametersAnyEmployee(view.employeePayload);

                }).then(map => {

                    view.employeeWeeklyParametersMap = map;
                    let employeeEmployeeWeeklyParametersMap = {};
                    Object.values(view.employeeMap)
                        .forEach(employee => {
                            Object.values(view.employeeWeeklyParametersMap)
                                .filter(params => params.employeeId == employee.id)
                                .forEach(params => {
                                    if (!employeeEmployeeWeeklyParametersMap[employee.id]) {
                                        employeeEmployeeWeeklyParametersMap[employee.id] = [];
                                    }
                                    employeeEmployeeWeeklyParametersMap[employee.id].push(Object.assign({}, params));
                                });
                        });
                    view.employeeEmployeeWeeklyParametersMap = employeeEmployeeWeeklyParametersMap;

                    if (view.detailedMode) {
                        view.state = 2;
                    }
                    return new Promise((resolve, reject) => {
                        resolve();
                    })
                }).catch(error => {
                    view.error = true;
                    if (error.msg != null) {
                        view.errorMsg = error.msg;
                    } else {
                        console.log(error);
                        view.errorMsg = this.$t('roster.main.loadStage2Error')
                    }
                    return new Promise((resolve, reject) => {
                        reject(this.$t('global.notifications.dataLoadingError'));
                    })
                })

        },
        confirmStage2: function () {
            if (this.employeeOptions.filter(i => i.checked === true).length < 1) {
                this.error = true;
                this.errorMsg = this.$t('roster.main.needEmployeeToPlan');
                return new Promise((resolve, reject) => {
                    reject(this.$t('roster.main.noEmployeeToPlan'));
                });
            } else {
                return this.prepareStage3(this.employeePayload);
            }


        },
        prepareStage3: function (employeepayload) {
            let view = this;
            return this.loadPreviousMonthEmployeeWorkBalances(employeepayload)
                .then(response => {
                    view.updatePreviousMonthEmployeeWorkBalances(response.data);
                    return view.loadEmployeeAvailabilityAnyEmployee(employeepayload);
                }).then(response => {
                    view.calculateEmployeeAvailabilityOptions(response.data);
                    return view.loadEmployeePreferenceAnyEmployee(employeepayload);
                }).then(response => {
                    view.calculateEmployeePreferenceOptions(response.data);

                    return view.loadEmployeeContractsAnyEmployee(employeepayload);
                }).then(response => {
                    view.employeeContractMap = {};
                    for (let i = 0; i < response.data.length; i++) {
                        let contract = response.data[i];
                        if (view.employeeContractMap[contract.employeeId] == null) {
                            view.employeeContractMap[contract.employeeId] = []
                        }
                        view.employeeContractMap[contract.employeeId].push(contract);
                    }

                    view.checkMissingContractIntervals(employeepayload.ids);
                    if (view.detailedMode) {
                        view.state = 3;
                    }
                    return new Promise((resolve, reject) => {
                        resolve();
                    })
                }).catch(error => {
                    view.error = true;
                    if (error.msg != null) {
                        view.errorMsg = error.msg;
                    } else {
                        console.log(error);
                        view.errorMsg = this.$t('roster.main.loadStage3Error')
                    }
                    return new Promise((resolve, reject) => {
                        reject(this.$t('global.notifications.dataLoadingError'));
                    })
                })

        },
        confirmStage3: function () {


            this.employeeAvailabilityMap = {};
            this.employeePreferenceMap = {};

            var i;
            for (i = 0; i < this.employeeAvailabilityOptions.length; i++) {
                if (this.employeeAvailabilityOptions[i].checked) {
                    if (this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId] != null) {
                        this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId].push(this.employeeAvailabilityOptions[i].value)
                    } else {
                        this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId] = [];
                        this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId].push(this.employeeAvailabilityOptions[i].value)
                    }
                }

            }
            for (i = 0; i < this.employeePreferenceOptions.length; i++) {
                if (this.employeePreferenceOptions[i].checked) {
                    if (this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId] != null) {
                        this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId].push(this.employeePreferenceOptions[i].value)
                    } else {
                        this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId] = [];
                        this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId].push(this.employeePreferenceOptions[i].value)
                    }
                }
            }


            return this.prepareStage4(this.spotPayload, this.employeePayload);

        },
        prepareStage4: function (spotPayload, employeePayload) {
            let view = this;


            let tShifts;
            return this.loadShiftsAnySpotAnyEmployee(spotPayload, employeePayload)
                .then(response => {
                    let shiftMap = {}
                    let shiftPayload = {ids: []};
                    tShifts = response.data;
                    for (let i = 0; i < response.data.length; i++) {
                        shiftPayload.ids.push(response.data[i].id);
                        shiftMap[response.data[i].id] = response.data[i];
                    }


                    view.shiftMap = shiftMap;
                    return view.loadShiftSkillsAnyShift(shiftPayload);
                }).then(response => {

                    view.shiftSkillMap = {};
                    for (let i = 0; i < response.data.length; i++) {
                        let skillId = response.data[i].skillId;
                        let shiftId = response.data[i].shiftId;
                        if (!view.shiftSkillMap[shiftId]) {
                            view.shiftSkillMap[shiftId] = []
                        }
                        view.shiftSkillMap[shiftId].push({
                            skillId: skillId,
                            required: response.data[i].required,
                            minValue: response.data[i].minValue,
                            maxValue: response.data[i].maxValue
                        })

                    }


                    return view.$helpers.GetActualShiftMap();
                }).then(map => {

                    view.actualShiftMap = map;
                    let employeeDateActualShiftMap = {};
                    Object.values(view.actualShiftMap).forEach(entry => {
                        if (!employeeDateActualShiftMap[entry.employeeId]) {
                            employeeDateActualShiftMap[entry.employeeId] = {};
                        }
                        let employeeEntry = employeeDateActualShiftMap[entry.employeeId];
                        let dateKey = view.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                        if (!employeeEntry[dateKey]) {
                            employeeEntry[dateKey] = [];
                        }
                        employeeEntry[dateKey].push(entry);
                    })
                    view.employeeDateActualShiftMap = employeeDateActualShiftMap;
                    view.calculateShiftOptions();
                    view.calculateActualShiftOptions();

                    return view.$helpers.GetActualBreakMap();

                }).then(map => {
                    let actualBreakMap = {};
                    Object.values(map).filter(entry => view.actualShiftMap[entry.shiftId] != null).forEach(entry => {
                        if (!actualBreakMap[entry.shiftId]) {
                            actualBreakMap[entry.shiftId] = [];
                        }
                        actualBreakMap[entry.shiftId].push(entry);
                    });

                    view.actualBreakMap = actualBreakMap;
                    if (view.detailedMode) {
                        view.state = 4;
                    }
                    return new Promise((resolve, reject) => {
                        resolve();
                    })

                }).catch(error => {
                    view.error = true;
                    if (error.msg != null) {
                        view.errorMsg = error.msg;
                    } else {
                        console.log(error);
                        view.errorMsg = this.$t('roster.main.loadStage4Error')
                    }
                    return new Promise((resolve, reject) => {
                        reject(this.$t('global.notifications.dataLoadingError'));
                    })
                })

        },
        checkEmployeeCanDoShift(employeeId, shiftId, spotId) {
            let hasSpotSkill = this.employeeSkillMap[employeeId] && this.spotMap[spotId] && this.employeeSkillMap[employeeId][this.spotMap[spotId].requiredSkill]
            let hasRequiredSkills = true;
            if (this.shiftSkillMap[shiftId]) {
                for (let i = 0; i < this.shiftSkillMap[shiftId].length; i++) {
                    let shiftSkill = this.shiftSkillMap[shiftId][i];
                    if (shiftSkill.required) {
                        let employeeHasSkill = this.employeeSkillMap[employeeId] &&
                            this.employeeSkillMap[employeeId][shiftSkill.skillId] &&
                            this.employeeSkillMap[employeeId][shiftSkill.skillId].value <= shiftSkill.maxValue &&
                            this.employeeSkillMap[employeeId][shiftSkill.skillId].value >= shiftSkill.minValue;
                        if (!employeeHasSkill) {
                            hasRequiredSkills = false;
                            break;
                        }
                    }
                }
            }
            return hasSpotSkill && hasRequiredSkills;
        },
        confirmStage4: function () {
            if (this.shiftOptions.filter(i => i.checked === true).length < 1) {
                this.error = true;
                this.errorMsg = this.$t('roster.main.selectShiftPlease');
                return new Promise((resolve, reject) => {
                    reject(this.$t('roster.main.noShiftToPlan'));
                });
            } else {
                this.error = false;
                return this.prepareStage5();
            }
        },

        prepareStage5: function () {
            let view = this;
            return this.loadRuleProfiles()
                .then(response => {
                    view.ruleProfileMap = {};
                    for (let i = 0; i < response.data.length; i++) {
                        view.ruleProfileMap[response.data[i].id] = response.data[i];
                    }
                    view.ruleProfiles = response.data;
                    view.setEnabledRulesMap();

                    view.planDates = [];
                    let from = view.$helpers.getMomentFromValuesTZ(view.rosterFromTo.year, view.rosterFromTo.month, 1);
                    let to = view.$helpers.getMomentFromStringTZ(view.rosterFromTo.to);
                    while (from < to) {
                        let key = from.format('DD.MM.YYYY');
                        let option = {id: key, label: key, value: from.clone()}
                        view.planDates.push(option)
                        from = from.add(1, 'days')
                    }
                    view.planFrom = view.planDates[0].value;
                    view.planTo = view.planDates[view.planDates.length - 1].value;


                    if (view.detailedMode) {
                        view.state = 5;
                    }
                    return new Promise((resolve, reject) => {
                        resolve();
                    })
                })
                .catch(error => {
                    view.error = true;
                    if (error.msg != null) {
                        view.errorMsg = error.msg;
                    } else {
                        console.log(error);
                        view.errorMsg = this.$t('roster.main.loadStage5Error')
                    }
                    return new Promise((resolve, reject) => {
                        reject(this.$t('global.notifications.dataLoadingError'));
                    })
                })

        },
        confirmStage5: function () {
            let view = this;
            view.selectedEmployeeOptions = view.employeeOptions.filter(i => i.checked === true);
            view.selectedEmployeeSpots = view.employeeSpotOptions.filter(i => i.checked === true);
            view.selectedShiftSpots = view.spotOptions.filter(i => i.checked === true);
            console.log(view.selectedShiftSpots.length)
            if (this.shiftStartFrom >= this.shiftStartTo && this.useShiftStartFilter) {
                view.$helpers.error(view.$t('roster.main.shiftFilterError'), view.$t('roster.main.startBeforeEnd'));

            } else if (this.shiftEndFrom >= this.shiftEndTo && this.useShiftEndFilter) {
                view.$helpers.error(view.$t('roster.main.shiftFilterError'), view.$t('roster.main.endBeforeEnd'));

            } else {

                let payload = this.buildAutoSchedulerRequest(this.storeSettings, this.holidayMap, this.spotMap, this.skillMap, this.shiftMap, this.shiftSkillMap, this.employeeMap,
                    this.employeeRulesMap, this.employeeSkillMap, this.employeeTypeMap, this.employeeAvailabilityMap, this.employeePreferenceMap, this.employeeGroupMap);
                this.sendingRequest = true;
                if (this.$parent && this.$parent.Close) this.$parent.Close();
                this.submitRosterRequest(payload)
                    .then(response => {
                        view.sendingRequest = false;
                        view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.main.planningStarted'));
                        VueEventBus.$emit('autoscheduling-submitted', {});
                    }).catch(error => {
                    view.sendingRequest = false;
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.sendPlanningError'));

                });
            }


        },
        buildAutoSchedulerRequest: function (storeSetting, holidayMap, spotMap, skillMap, shiftMap, shiftSkillMap, employeeMap, employeeRulesMap, employeeSkillMap, employeeTypeMap, employeeAvailabilityMap, employeePreferenceMap, groupMap) {
            //DONT TOUCH UNLESS YOU KNOW WHAT YOU ARE DOING
            let view = this;
            let customEntityMapping = {};
            let spotMapping = {}, employeeMapping = {}, skillMapping = {}, shiftMapping = {}, typeMapping = {};
            let requestSpotMap = {}, requestEmployeeMap = {}, requestSkillMap = {}, requestShiftMap = {},
                requestTypeMap = {}, requestPreferenceMap = {};
            let spotRequestId = 1, employeeRequestId = 1, skillRequestId = 1, shiftRequestId = 1, typeRequestId = 1,
                preferenceRequestId = 1;
            //build request skillMap
            customEntityMapping.skillMapping = {}
            let key = null;
            for (key in skillMap) {
                if (skillMap.hasOwnProperty(key)) {
                    let skill = skillMap[key];
                    let requestkey = "" + skillRequestId;
                    skillMapping[skill.id] = skillRequestId;
                    let requestSkill = {id: skillRequestId, name: skill.name}
                    requestSkillMap[requestkey] = requestSkill;
                    customEntityMapping.skillMapping[requestkey] = {originalId: skill.id, hash: skill.hash};
                    skillRequestId++;
                }
            }
            //build request spotMap
            customEntityMapping.spotMapping = {};
            for (key in spotMap) {
                if (spotMap.hasOwnProperty(key)) {
                    let spot = spotMap[key];
                    let requestkey = "" + spotRequestId;
                    spotMapping[spot.id] = spotRequestId;
                    let requestSpot = {id: spotRequestId, name: spot.name}
                    if (spot.requiredSkill != null && skillMapping[spot.requiredSkill] != null) {
                        requestSpot.requiredSkillId = skillMapping[spot.requiredSkill];
                    }
                    requestSpotMap[requestkey] = requestSpot;
                    customEntityMapping.spotMapping[requestkey] = {originalId: spot.id, hash: null};
                    spotRequestId++;
                }
            }
            //build request employeeTypeMap with rules
            //flag for enabling double sunday rule
            let doubleSundayRule = false;

            //build request employeeMap and employeeTypeMap
            customEntityMapping.employeeMapping = {}
            var j;
            let currentDate = this.$helpers.getMomentTZ();
            let monthDays = this.$helpers.CalculateDaysCount(this.currentMonthFrom);
            let mFrom = this.currentMonthFrom.clone().startOf('month');
            let mTo = this.currentMonthFrom.clone().endOf('month').add(1, 'days').startOf('day');
            let monthWorkDays = this.$helpers.CalculateBusinessDaysCount(mFrom, mTo, storeSetting.workTimeMode == 3 ? Object.values(holidayMap).filter(h => h.active && h.federalHoliday).map(h => view.$helpers.getMomentFromStringTZ(h.from)) : []);

            for (key in employeeMap) {
                if (employeeMap.hasOwnProperty(key)) {
                    let employee = employeeMap[key];

                    let contractType = (view.employeeContractMap[employee.id] && view.employeeContractMap[employee.id].length) > 0 ? view.employeeContractMap[employee.id][0].contractType : 1;
                    //console.log(JSON.stringify(employee));
                    if (!this.$helpers.isBlank(employee.ruleId) && !this.$helpers.isBlank(employeeRulesMap[employee.ruleId]) && !this.$helpers.isBlank(this.employeeInfos[employee.id]) && !this.$helpers.isBlank(this.employeeInfos[employee.id].type) && this.employeeInfos[employee.id].type.weekTimeRegular > 0) {

                        let age = employee.dob ? currentDate.diff(this.$helpers.getMomentFromStringTZ(employee.dob), 'years') : 25;
                        let pregnant = this.calculatePregnantFlagFromContracts(employee.id);
                        let overtimeCutoffs = this.calculateOvertimeCutoffs(employee.id, this.storeSettings);

                        let employeeType = this.employeeInfos[employee.id].type;
                        let requestkey = "" + typeRequestId;

                        let weekTimeRegular = employeeType.weekTimeRegular > 0 ? employeeType.weekTimeRegular : 40 * 60;
                        let weekWorkDaysRegular = employeeType.weekWorkDaysRegular > 0 ? employeeType.weekWorkDaysRegular : 5;
                        let wtMultiplier = this.calculateWorkTimePercentagesFromContracts(employee.id);
                        if (wtMultiplier == null) {
                            wtMultiplier = 1.0;
                        }
                        //console.log(employee.lastName+" "+employee.firstName +" - "+wtMultiplier);
                        let requestType = {
                            id: typeRequestId, name: "",
                            monthTimeRegular: Math.round(this.$helpers.CalculateMonthWorkTime(monthWorkDays, monthDays, weekTimeRegular, weekWorkDaysRegular, null, this.storeSettings.workTimeMode, this.storeSettings) * wtMultiplier),
                            dayTimeMax: this.storeSettings.allowShiftOvertime ? employeeType.dayTimeMax : overtimeCutoffs.overtimeCutoff,
                            dayTimeRegular: employeeType.dayTimeRegular,
                            daysConsecutiveMax: employeeType.daysConsecutiveMax,
                            interDayBetweenTimeMin: employeeType.restTime,
                            monthOvertimeMax: employeeType.monthOvertimeMax,
                            overtimeCutoff: employeeType.overtimeCutoff,
                            rules: {}, rulesScaling: {}, rulesLevels: {}
                        }

                        //Youths and pregnant women are only allowed to work 9h max per day in Austria, TODO: handle other countries
                        if ((age < 18 && this.applyYouthRules) || (pregnant && this.applyPregnancyRules)) {
                            if (storeSetting.country == 1) {
                                requestType.dayTimeMax = requestType.dayTimeMax < 0 ? 9 * 60 : Math.min(9 * 60, requestType.dayTimeMax);
                            } else {
                                requestType.dayTimeMax = requestType.dayTimeMax < 0 ? 8 * 60 : Math.min(8 * 60, requestType.dayTimeMax);
                            }

                        }
                        if (this.previousMonthWorkBalanceMap[employee.id]) {
                            if (this.planWithPreviousMonth) {
                                requestType.monthTimeRegular = Math.max(0, requestType.monthTimeRegular - this.previousMonthWorkBalanceMap[employee.id].workTimeBalance)
                            }
                            if (this.planWithHolidayBalance) {
                                requestType.monthTimeRegular = Math.max(0, requestType.monthTimeRegular - this.previousMonthWorkBalanceMap[employee.id].holidayTimeBalance);
                            }
                        }
                        requestType.monthTimeRegular = Math.max(0, Math.round(requestType.monthTimeRegular * this.monthTimeRegularPercentage / 100));
                        if (requestType.daysConsecutiveMax > -1 && this.enabledRulesMap['2'].checked) {
                            this.rosterConfiguration.rules["2"] = 1;
                        }
                        if (requestType.monthOvertimeMax > -1 && this.enabledRulesMap['3'].checked) {
                            this.rosterConfiguration.rules["3"] = 1;
                        }
                        if (employeeType.shiftBetweenTimeMin > -1) {
                            requestType.betweenTimeMin = employeeType.shiftBetweenTimeMin;
                            requestType.interDayBetweenTimeMin = employeeType.restTime;
                            requestType.intraDayBetweenMax = employeeType.shiftBetweenTimeMax;
                            //youths need 12h rest between days when under 18, 14 when under 15 in austria TODO: handle other countries?
                            if (age < 18 && this.applyYouthRules) {
                                requestType.interDayBetweenTimeMin = Math.max(12 * 60, employeeType.restTime);
                                if (age < 15) {
                                    requestType.interDayBetweenTimeMin = Math.max(14 * 60, employeeType.restTime);
                                }
                            }
                        } else {
                            requestType.betweenTimeMin = employeeType.restTime;
                            requestType.intraDayBetweenMax = -1;
                            //youths need 12h rest between days when under 18, 14 when under 15 in austria TODO: handle other countries?
                            if (age < 18 && this.applyYouthRules) {
                                requestType.betweenTimeMin = Math.max(12 * 60, employeeType.restTime);
                                if (age < 15) {
                                    requestType.betweenTimeMin = Math.max(14 * 60, employeeType.restTime);
                                }
                            }
                        }

                        //Youths and pregnant women are not allowed to work overtime in Austria, TODO: handle other countries
                        if ((age < 18 && this.applyYouthRules) || (pregnant && this.applyPregnancyRules)) {
                            requestType.monthTimeMax = requestType.monthTimeRegular;
                            requestType.rules["7"] = 1;
                        } else if (employeeType.monthTimeMaxType === 2) {
                            requestType.monthTimeMax = Math.max(0, requestType.monthTimeRegular + employeeType.monthTimeMaxAdjustment);
                            requestType.rules["7"] = 1;
                        } else if (employeeType.monthTimeMaxType === 3) {
                            requestType.monthTimeMax = requestType.monthTimeRegular;
                            requestType.rules["7"] = 1;
                        } else {
                            requestType.monthTimeMax = -1;
                        }


                        if (employeeType.weekTimeAvgType === 2 && this.enabledRulesMap['29'].checked) {
                            requestType.rules["29"] = 1;
                            this.rosterConfiguration.rules["29"] = 1;
                        }
                        if (employeeType.weekTimeAvgType === 3 && this.enabledRulesMap['30'].checked) {
                            requestType.rules["30"] = 1;
                            this.rosterConfiguration.rules["30"] = 1;
                        }

                        requestType.defaultWeeklyParams = {
                            weekTimeMax: this.storeSettings.allowShiftOvertime ? employeeType.weekTimeMax : overtimeCutoffs.weeklyOvertimeCutoff,
                            weekTimeRegular: employeeType.weekTimeRegular,
                            weekWorkDaysMax: employeeType.weekWorkDaysMax,
                            weekWorkDaysRegular: employeeType.weekWorkDaysRegular,
                            weekSpareTimeMin: Math.min(employeeType.weekSpareTimeMin, 10080),
                            weekSpareDaysMin: employeeType.weekSpareDaysMin
                        }
                        //youth and pregnant women are only allowed to work 40h max/week in austria TODO: handle other countries?
                        if ((age < 18 && this.applyYouthRules) || (pregnant && this.applyPregnancyRules)) {
                            requestType.defaultWeeklyParams.weekTimeMax = requestType.defaultWeeklyParams.weekTimeMax < 0 ? 40 * 60 : Math.min(40 * 60, requestType.defaultWeeklyParams.weekTimeMax);
                        }
                        //youths required 2 full days off / week
                        if (age < 18 && this.applyYouthRules) {
                            requestType.defaultWeeklyParams.weekSpareTimeMin = Math.max(requestType.defaultWeeklyParams.weekSpareTimeMin, 2 * 24 * 60);
                            requestType.defaultWeeklyParams.weekSpareDaysMin = Math.max(requestType.defaultWeeklyParams.weekSpareDaysMin, 2);

                        }
                        if (requestType.defaultWeeklyParams.weekWorkDaysMax > -1 && this.enabledRulesMap['4'].checked) {
                            this.rosterConfiguration.rules["4"] = 1;
                        }
                        if (employeeType.weekSpareTimeStartType == 2 && !this.$helpers.isBlank(employeeType.weekSpareTimeStart) && this.enabledRulesMap['31'].checked) {
                            requestType.defaultWeeklyParams.spareTimeStartRegular = view.$helpers.getMomentFromStringTZ(employeeType.weekSpareTimeStart, "HH:mm").format("HH:mm");
                            requestType.rules["31"] = 1;
                            this.rosterConfiguration.rules["31"] = 1;
                        } else if (employeeType.weekSpareTimeStartType == 3 && !this.$helpers.isBlank(employeeType.weekSpareTimeStart) && this.enabledRulesMap['31'].checked) {
                            requestType.defaultWeeklyParams.spareTimeStartRegular = view.$helpers.getMomentFromStringTZ(employeeType.weekSpareTimeStart, "HH:mm").format("HH:mm");
                            requestType.defaultWeeklyParams.spareTimeStartRequired = view.$helpers.getMomentFromStringTZ(employeeType.weekSpareTimeStart, "HH:mm").format("HH:mm");
                            requestType.rules["31"] = 1;
                            this.rosterConfiguration.rules["31"] = 1;
                        }

                        requestType.weeklyParams = {};
                        if (this.employeeEmployeeWeeklyParametersMap[employee.id]) {
                            this.employeeEmployeeWeeklyParametersMap[employee.id].forEach(params => {
                                let weeklyParam = {
                                    weekTimeMax: this.storeSettings.allowShiftOvertime ? params.weekTimeMax : overtimeCutoffs.weeklyOvertimeCutoff,
                                    weekTimeRegular: params.weekTimeRegular,
                                    weekWorkDaysMax: params.weekWorkDaysMax,
                                    weekWorkDaysRegular: params.weekWorkDaysRegular,
                                    weekSpareTimeMin: Math.min(params.weekSpareTimeMin, 10080),
                                    weekSpareDaysMin: params.weekSpareDaysMin,
                                }
                                if ((age < 18 && this.applyYouthRules) || (pregnant && this.applyPregnancyRules)) {
                                    weeklyParam.weekTimeMax = weeklyParam.weekTimeMax < 0 ? 40 * 60 : Math.min(40 * 60, weeklyParam.weekTimeMax);
                                }
                                //youths required 2 full days off / week
                                if (age < 18 && this.applyYouthRules) {
                                    weeklyParam.weekSpareTimeMin = Math.max(weeklyParam.weekSpareTimeMin, 2 * 24 * 60);
                                    weeklyParam.weekSpareDaysMin = Math.max(weeklyParam.weekSpareDaysMin, 2);
                                }
                                let date = this.$helpers.getMomentFromStringTZ(params.date);
                                let key = date.isoWeekYear() + '' + date.isoWeek();
                                if (weeklyParam.weekWorkDaysMax > -1) {
                                    this.rosterConfiguration.rules["4"] = 1;
                                }
                                requestType.weeklyParams[key] = weeklyParam;
                            });
                        }


                        let employeeRules = employeeRulesMap[employee.ruleId];

                        if (employeeRules.rules["desiredR"] != undefined && employeeRules.rules["desiredR"] > 0 && this.enabledRulesMap['9'].checked) {
                            requestType.rules["9"] = employeeRules.rules["desiredR"];
                            this.rosterConfiguration.rules["9"] = 1;
                        }
                        if (employeeRules.rules["undesiredR"] != undefined && employeeRules.rules["undesiredR"] > 0 && this.enabledRulesMap['10'].checked) {
                            requestType.rules["10"] = employeeRules.rules["undesiredR"];
                            this.rosterConfiguration.rules["10"] = 1;
                        }
                        if (employeeRules.rules["weekendR"] != undefined && employeeRules.rules["weekendR"] > 0 && this.enabledRulesMap['12'].checked) {
                            requestType.rules["12"] = employeeRules.rules["weekendR"];
                            this.rosterConfiguration.rules["12"] = 1;
                        }
                        if (employeeRules.rules["weekendDaysR"] != undefined && employeeRules.rules["weekendDaysR"] > 0 && this.enabledRulesMap['13'].checked) {
                            requestType.rules["13"] = employeeRules.rules["weekendDaysR"];
                            this.rosterConfiguration.rules["13"] = 1;
                        }
                        if (employeeRules.rules["skillR"] != undefined && employeeRules.rules["skillR"] > 0 && this.enabledRulesMap['15'].checked) {
                            requestType.rules["15"] = employeeRules.rules["skillR"];
                            this.rosterConfiguration.rules["15"] = 1;
                        }
                        if (employeeRules.rules["fairnessDefinitionR"] != undefined && employeeRules.rules["fairnessDefinitionR"] > 0 && this.enabledRulesMap['16'].checked) {
                            requestType.rules["16"] = employeeRules.rules["fairnessDefinitionR"];
                            this.rosterConfiguration.rules["16"] = 1;
                        }
                        if (employeeRules.rules["bioR"] != undefined && employeeRules.rules["bioR"] > 0 && this.enabledRulesMap['24'].checked) {
                            requestType.rules["24"] = employeeRules.rules["bioR"];
                            this.rosterConfiguration.rules["24"] = 1;
                        }

                        if (age < 18 && this.applyYouthRules) {
                            requestType.rules["20"] = 1
                            this.rosterConfiguration.rules["20"] = 1;
                        }
                        if (this.contractTypeMap['' + contractType] != null && this.contractTypeMap['' + contractType] > 1) {

                            /*for(let levelKey in requestType.rules){
                                requestType.rulesLevels[levelKey] = this.contractTypeMap[''+contractType];
                            }*/
                            requestType.rulesLevels["19"] = this.contractTypeMap['' + contractType]
                            //requestType.rules["19"] = this.contractTypeMap[''+contractType]
                        }
                        requestType.rules["19"] = 1;
                        requestTypeMap[requestkey] = requestType;

                        requestkey = "" + employeeRequestId;
                        employeeMapping[employee.id] = employeeRequestId;
                        let requestEmployee = {
                            id: employeeRequestId,
                            name: employee.lastName + employee.firstName,
                            typeId: requestType.id,
                            skillProficiencyMap: {}
                        }

                        let employeeWasSelected = view.selectedEmployeeOptions.filter(i => i.id == employee.id).length > 0;
                        let employeeSpotWasSelected = employee.spotId == null || view.selectedEmployeeSpots.filter(i => i.id == employee.spotId).length > 0;
                        if (employeeSkillMap[key] != undefined) {
                            for (let skillId in employeeSkillMap[key]) {
                                if (skillMapping[skillId] != null && this.contractTypeMap['' + contractType] != null && employeeWasSelected && employeeSpotWasSelected) { //check if skill id was ever put in skillMapping and therefore has request id
                                    requestEmployee.skillProficiencyMap["" + skillMapping[skillId]] = {
                                        skillId: skillMapping[skillId],
                                        value: employeeSkillMap[key][skillId].value
                                    };
                                }
                            }
                        }

                        requestEmployeeMap[requestkey] = requestEmployee;
                        customEntityMapping.employeeMapping[requestkey] = {
                            originalId: employee.id,
                            hash: employee.hash
                        };
                        employeeRequestId++;
                        typeRequestId++;

                    }

                }
            }


            if (this.enabledRulesMap['17'].checked) {
                this.rosterConfiguration.rules["17"] = 1;
            }
            if (this.enabledRulesMap['18'].checked) {
                this.rosterConfiguration.rules["18"] = 1;
            }
            if (this.enabledRulesMap['27'].checked) {
                this.rosterConfiguration.rules["27"] = 1;
            }
            //build request timeSlotDefinitions Map
            customEntityMapping.shiftMapping = {}

            let actualPlanTo = view.planTo.clone().add(1, 'days');
            for (key in shiftMap) {
                if (shiftMap.hasOwnProperty(key)) {
                    let shift = shiftMap[key];

                    if (!(this.noPlanShiftIds.includes(shift.id))) {
                        let requestkey = "" + shiftRequestId;
                        shiftMapping[shift.id] = shiftRequestId;
                        let shiftStartDate = this.$helpers.getMomentFromStringTZ(shift.from);
                        let workDayIndex = this.calculateWorkDayIndex(shiftStartDate);
                        let shiftEndDate = this.$helpers.getMomentFromStringTZ(shift.to);

                        let workValue = 0;
                        if (shift.workValue === -1) {
                            workValue = shiftEndDate.diff(shiftStartDate, 'minutes');
                        } else {
                            workValue = shift.workValue
                        }
                        workValue = Math.max(0, workValue - shift.breakValue);
                        let requestTimeSlot = {
                            id: shiftRequestId,
                            fromH: shiftStartDate.hours(),
                            fromM: shiftStartDate.minutes(),
                            toH: shiftEndDate.hours(),
                            toM: shiftEndDate.minutes(),
                            workValue: workValue,
                            count: 1,
                            locked: false,
                            requiredSkills: {}, optionalSkills: []
                        }
                        if (shift.spotId != null && spotMapping[shift.spotId] != undefined) {
                            requestTimeSlot.spotId = spotMapping[shift.spotId];
                        }

                        let prevMonth = this.rosterConfiguration.month - 1;
                        if (prevMonth == 0) {
                            prevMonth = 12;
                        }
                        let isPreviousMonthShift = shiftStartDate.month() + 1 == prevMonth;

                        let isInsidePlanInterval = shiftStartDate >= view.planFrom && shiftStartDate < actualPlanTo;


                        if (shift.employeeId != null && employeeMapping[shift.employeeId] != undefined && (shift.pinned || shift.published || isPreviousMonthShift || !isInsidePlanInterval)) {
                            requestTimeSlot.employeeId = employeeMapping[shift.employeeId];
                        }
                        //if shift was manually pinned, is already published, wasnt selected for planning or is from previous month (rosterConfig.month starts with 1) then pin it
                        if ((shift.pinned && shift.employeeId != null) || shift.published || !this.selectedShiftIds.includes(shift.id) || isPreviousMonthShift || !isInsidePlanInterval) {

                            requestTimeSlot.locked = true;
                        }
                        //also pin shift if not in spot selection
                        if (shift.spotId != null && this.selectedShiftSpots.filter(i => i.id == shift.spotId).length == 0) {
                            requestTimeSlot.locked = true;
                            if (shift.employeeId != null) {
                                //shift is assigned to employee but should not be planned -> need to send it anyway
                                requestTimeSlot.employeeId = employeeMapping[shift.employeeId];
                            }
                        } 
                        //also pin shift if it start or end filters are active and it is in neither
                        if (this.useShiftStartFilter || this.useShiftEndFilter) {
                            let from = this.shiftStartFrom * 60;
                            let to = this.shiftStartTo * 60;
                            let matchesFilter = false;
                            if (this.useShiftStartFilter && shiftStartDate.hours() * 60 >= from * 60 && shiftStartDate.hours() * 60 < to) {
                                matchesFilter = true;
                            }

                            from = this.shiftEndFrom * 60;
                            to = this.shiftEndTo * 60;
                            if (this.useShiftEndFilter && shiftEndDate.hours() * 60 >= from && shiftEndDate.hours() * 60 < to) {
                                matchesFilter = true;
                            }

                            if (!matchesFilter) {
                                requestTimeSlot.locked = true;
                            }
                        }
                        if (this.useShiftDurationFilter) {
                            let shiftDuration = shiftEndDate.diff(shiftStartDate, 'minutes');
                            if (shiftDuration < this.shiftDurationMin || shiftDuration > this.shiftDurationMax) {
                                requestTimeSlot.locked = true;
                            }
                        }

                        if (shiftSkillMap[key] != undefined) {
                            for (j = 0; j < shiftSkillMap[key].length; j++) {
                                let shiftSkill = shiftSkillMap[key][j];

                                if (skillMapping[shiftSkill.skillId] != null) { //check if skill id was ever put in skillMapping and therefore has request id
                                    if (shiftSkill.required) {
                                        requestTimeSlot.requiredSkills[skillMapping[shiftSkill.skillId]] = shiftSkill.minValue;
                                        requestTimeSlot.requiredSkills[-1 * skillMapping[shiftSkill.skillId]] = shiftSkill.maxValue + 1;
                                    } else {
                                        requestTimeSlot.optionalSkills.push(skillMapping[shiftSkill.skillId])
                                    }

                                }
                            }
                        }

                        if (requestShiftMap["" + workDayIndex] === undefined) {
                            requestShiftMap["" + workDayIndex] = {}
                        }
                        let addToRequest = true;
                        
                        if(!requestTimeSlot.employeeId && requestTimeSlot.locked == true){
                            addToRequest = false;
                        }

                        if(addToRequest){
                            //only add shift if it is either not locked or is locked but has employee assigned
                            requestShiftMap["" + workDayIndex][requestkey] = requestTimeSlot;
                            customEntityMapping.shiftMapping[requestkey] = {originalId: shift.id, hash: shift.hash};
                            shiftRequestId++;
                        }
                       
                    }

                }
            }
            if (this.useActualShifts) {
                Object.values(this.actualShiftMap).forEach(shift => {
                    if (!this.$helpers.isBlank(this.employeeInfos[shift.employeeId]) && !this.$helpers.isBlank(this.employeeInfos[shift.employeeId].type)) {
                        let requestkey = "" + shiftRequestId;
                        shiftMapping[shift.id] = shiftRequestId;
                        let shiftStartDate = this.$helpers.getMomentFromStringTZ(shift.from);
                        let workDayIndex = this.calculateWorkDayIndex(shiftStartDate);
                        let shiftEndDate = this.$helpers.getMomentFromStringTZ(shift.to);

                        let workValue = shiftEndDate.diff(shiftStartDate, 'minutes');
                        let totalBreakValue = 0;
                        if (this.actualBreakMap[shift.id]) {
                            this.actualBreakMap[shift.id].forEach(abreak => {
                                let breakStartDate = this.$helpers.getMomentFromStringTZ(abreak.from);
                                let breakEndDate = this.$helpers.getMomentFromStringTZ(abreak.to);
                                totalBreakValue += breakEndDate.diff(breakStartDate, 'minutes');
                            });
                        }
                        workValue = Math.max(0, workValue - totalBreakValue);
                        let requestTimeSlot = {
                            id: shiftRequestId,
                            employeeId: employeeMapping[shift.employeeId],
                            fromH: shiftStartDate.hours(),
                            fromM: shiftStartDate.minutes(),
                            toH: shiftEndDate.hours(),
                            toM: shiftEndDate.minutes(),
                            workValue: workValue,
                            count: 1,
                            locked: true,
                            requiredSkills: {}, optionalSkills: []
                        }
                        if (requestShiftMap["" + workDayIndex] === undefined) {
                            requestShiftMap["" + workDayIndex] = {}
                        }
                        requestShiftMap["" + workDayIndex][requestkey] = requestTimeSlot;
                        customEntityMapping.shiftMapping[requestkey] = {originalId: shift.id, hash: ""};
                        shiftRequestId++;
                    }
                });
            }


            //map for storing availabilities per dayIndex per employee, need to check during preference loop whether there is a preference on same day that overwrites availabilities
            //if yes -> need to delete the entry
            let tempAvailabilityMap = {}
            for (key in employeeAvailabilityMap) {
                if (employeeAvailabilityMap.hasOwnProperty(key)) {
                    for (j = 0; j < employeeAvailabilityMap[key].length; j++) {
                        let employeeAvailability = employeeAvailabilityMap[key][j];
                        if (employeeAvailability.spotId == null || spotMapping[employeeAvailability.spotId] != undefined) {
                            let tempRosterStart = this.$helpers.getMomentFromValuesTZ(this.fullWeekPlanFrom.year(), this.fullWeekPlanFrom.month(), this.fullWeekPlanFrom.date(), 0, 0);
                            let tempRosterEnd = this.$helpers.getMomentFromValuesTZ(this.fullWeekPlanTo.year(), this.fullWeekPlanTo.month(), this.fullWeekPlanTo.date(), 0, 0);
                            let availStartDate = this.$helpers.getMomentFromStringUTC(employeeAvailability.from, 'HH:mm');
                            availStartDate = this.fullWeekPlanFrom.clone().hours(availStartDate.hours()).minutes(availStartDate.minutes());

                            let availEndDate = this.$helpers.getMomentFromStringUTC(employeeAvailability.to, 'HH:mm');
                            availEndDate = this.fullWeekPlanFrom.clone().hours(availEndDate.hours()).minutes(availEndDate.minutes());

                            if (availEndDate.diff(availStartDate) <= 0) {
                                availEndDate.add(24, 'hours');
                            }

                            while (tempRosterEnd.diff(tempRosterStart, 'minutes') > 0) {
                                let weekDay = tempRosterStart.isoWeekday();

                                let workDayIndex = this.calculateWorkDayIndex(tempRosterStart);

                                if (employeeAvailability.weekDays.includes(weekDay)
                                    && employeeAvailability.employeeId != null
                                    && employeeMapping[employeeAvailability.employeeId] != undefined) {
                                    let state = employeeAvailability.state;
                                    let stateStr = "";
                                    if (state == 1) {
                                        stateStr = "UNAVAILABLE";
                                    }
                                    if (state == 2) {
                                        stateStr = "AVAILABLE";
                                    }
                                    if (state == 3) {
                                        stateStr = "UNDESIRED";
                                    }
                                    if (state == 4) {
                                        stateStr = "DESIRED";
                                    }


                                    let requestAvailability = {
                                        id: -1, // set id later after preference loop
                                        fromH: availStartDate.hours(),
                                        fromM: availStartDate.minutes(),
                                        toH: availEndDate.hours(),
                                        toM: availEndDate.minutes(),
                                        employeeId: employeeMapping[employeeAvailability.employeeId],
                                        state: stateStr,
                                        exclusive: employeeAvailability.exclusive,
                                        factor: employeeAvailability.factor
                                    }
                                    if (employeeAvailability.spotId != null && spotMapping[employeeAvailability.spotId] != undefined) {
                                        requestAvailability.spotId = spotMapping[employeeAvailability.spotId];
                                    }


                                    if (tempAvailabilityMap[workDayIndex] === undefined) {
                                        tempAvailabilityMap[workDayIndex] = {};
                                    }
                                    if (tempAvailabilityMap[workDayIndex][requestAvailability.employeeId] === undefined) {
                                        tempAvailabilityMap[workDayIndex][requestAvailability.employeeId] = []
                                    }
                                    tempAvailabilityMap[workDayIndex][requestAvailability.employeeId].push(requestAvailability);

                                }
                                tempRosterStart.add(24, 'hours');
                                //availStartDate.setUTCHours(availStartDate.getUTCHours() + 24);
                                //availEndDate.setUTCHours(availEndDate.getUTCHours() + 24);
                            }
                        }
                    }
                }
            }


            for (key in employeePreferenceMap) {
                if (employeePreferenceMap.hasOwnProperty(key)) {
                    for (j = 0; j < employeePreferenceMap[key].length; j++) {
                        let pref = employeePreferenceMap[key][j];

                        if ((pref.spotId == null || spotMapping[pref.spotId] != undefined)
                            && pref.employeeId != null && employeeMapping[pref.employeeId] != undefined) {


                            let prefActualFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                            if (this.fullWeekPlanFrom.diff(prefActualFrom) > 0) {
                                prefActualFrom = this.fullWeekPlanFrom;
                            }
                            let prefActualTo = this.$helpers.getMomentFromStringTZ(pref.to);
                            if (prefActualTo.diff(this.fullWeekPlanTo) > 0) {
                                prefActualTo = this.fullWeekPlanTo;
                            }
                            let prefStartDate = prefActualFrom.clone().startOf('day');
                            let prefEndDate = prefActualTo.clone();
                            if (prefEndDate.format() != prefEndDate.clone().startOf('day').format()) {
                                prefEndDate = prefEndDate.startOf('day').add(1, 'days');
                            }

                            //loop through days
                            let prefDate = prefStartDate.clone();
                            while (prefEndDate.diff(prefDate) > 0) {
                                let workDayIndex = this.calculateWorkDayIndex(prefDate);

                                let state = pref.state;
                                let stateStr = "";
                                if (state == 1) {
                                    stateStr = "UNAVAILABLE";
                                }
                                if (state == 2) {
                                    stateStr = "AVAILABLE";
                                }
                                if (state == 3) {
                                    stateStr = "UNDESIRED";
                                }
                                if (state == 4) {
                                    stateStr = "DESIRED";
                                }

                                let requestPreference = {
                                    id: preferenceRequestId,
                                    state: stateStr,
                                    employeeId: employeeMapping[pref.employeeId],
                                    exclusive: pref.exclusive,
                                    factor: pref.factor
                                }
                                if (prefDate.format("DD-MM-YYYY") == prefActualFrom.format("DD-MM-YYYY")) {

                                    if (prefActualFrom.format("DD-MM-YYYY") == prefActualTo.format("DD-MM-YYYY")) {
                                        //if from and to are on same day, use actual hours/minutes
                                        requestPreference.fromH = prefActualFrom.hours();
                                        requestPreference.fromM = prefActualFrom.minutes();
                                        requestPreference.toH = prefActualTo.hours();
                                        requestPreference.toM = prefActualTo.minutes();
                                    } else {
                                        //not on same day, use actual from until midnight
                                        requestPreference.fromH = prefActualFrom.hours();
                                        requestPreference.fromM = prefActualFrom.minutes();
                                        requestPreference.toH = 0;
                                        requestPreference.toM = 0;
                                    }
                                } else if (prefDate.format("DD-MM-YYYY") == prefActualTo.format("DD-MM-YYYY")) {
                                    //index date arrived on same date as preference end date => end time must be after midnight/start of day => set preference from to midnight
                                    requestPreference.fromH = 0;
                                    requestPreference.fromM = 0;
                                    requestPreference.toH = prefActualTo.hours();
                                    requestPreference.toM = prefActualTo.minutes();
                                } else {
                                    //index date is neither at start or end => must be in between => pref is for full day
                                    requestPreference.fromH = 0;
                                    requestPreference.fromM = 0;
                                    requestPreference.toH = 0;
                                    requestPreference.toM = 0;
                                }
                                if (pref.state != 1 && pref.spotId != null && spotMapping[pref.spotId] != undefined) {
                                    requestPreference.spotId = spotMapping[pref.spotId];
                                }
                                if (pref.state == 1 && (this.employeeAvailabilityTypeMap[pref.type].productive || (pref.type == 4 && pref.alwaysWork))) {
                                    let from = prefActualFrom.clone().hours(requestPreference.fromH).minutes(requestPreference.fromM);
                                    let to = from.clone().hours(requestPreference.toH).minutes(requestPreference.toM);
                                    if (to <= from) {
                                        to = to.add(1, 'days');
                                    }
                                    let mainContract = this.getMainContract(pref.employeeId, from, to);
                                    let workDays = mainContract && mainContract.workDays.length > 0 ? mainContract.workDays : this.storeSettings.workDays;

                                    if (!workDays.includes(prefDate.isoWeekday()) && !pref.alwaysWork) {
                                        requestPreference.workValue = 0
                                    } else if (pref.workValue >= 0) {
                                        let endOfDay = prefDate.clone().add(1, 'days').startOf('day');
                                        let checkEnd = endOfDay < prefActualTo ? endOfDay : prefActualTo;
                                        let ratio = checkEnd.diff(prefDate) / prefActualTo.diff(prefActualFrom);

                                        requestPreference.workValue = Math.max(0, Math.round(pref.workValue * ratio));
                                    } else {
                                        let employee = employeeMap[pref.employeeId];
                                        let employeeType = employeeTypeMap[employee.typeId];

                                        let minutes = Math.max(0, to.diff(from, 'minutes'));

                                        let contractWorkDaysRegular = mainContract ? mainContract.weekWorkDaysRegular : 5;
                                        if (contractWorkDaysRegular == null) {
                                            contractWorkDaysRegular = employeeType.weekWorkDaysRegular;
                                        }
                                        let calculatedDayTimeRegular = (employeeType.weekTimeRegular > 0 && contractWorkDaysRegular > 0)
                                            ? Math.round(employeeType.weekTimeRegular / contractWorkDaysRegular)
                                            : (employeeType.dayTimeRegular > 0 ? employeeType.dayTimeRegular : 9 * 60);
                                        if (minutes > calculatedDayTimeRegular) {
                                            requestPreference.workValue = calculatedDayTimeRegular;
                                        } else {
                                            requestPreference.workValue = minutes;
                                        }
                                    }


                                    requestPreference.dayTimeF = true;
                                    requestPreference.weekTimeF = true;
                                    requestPreference.monthTimeF = true;


                                    if (workDays.includes(prefDate.isoWeekday()) || pref.alwaysWork) {
                                        requestPreference.convertF = true;
                                        requestPreference.workDayF = true;
                                        if (this.employeePreferenceRestTimeMap['' + pref.type] && this.employeePreferenceRestTimeMap['' + pref.type].selected) {
                                            requestPreference.allowedRules = [1];
                                        }
                                    } else {
                                        requestPreference.convertF = false;
                                        requestPreference.workDayF = false;
                                    }

                                }


                                if (pref.overrideContract && pref.state == 1) { //if preference overrides availabilities, delete all availabilties for that day for that employee
                                    if (tempAvailabilityMap[workDayIndex] != undefined && tempAvailabilityMap[workDayIndex][requestPreference.employeeId] != undefined) {
                                        let newAvails = [];
                                        tempAvailabilityMap[workDayIndex][requestPreference.employeeId].forEach(avail => {
                                            if (avail.stateStr == "UNAVAILABLE") {
                                                newAvails.push(avail);
                                            }
                                        })
                                        tempAvailabilityMap[workDayIndex][requestPreference.employeeId] = newAvails;

                                    }
                                    /*//in case that the preference goes over midnight we need to delete the availabilities of next day too
                                let tprefEndDate = this.$helpers.getMomentFromValuesTZ(prefDate.year(), prefDate.month(), prefDate.date(), prefEndDate.hours(), prefEndDate.minutes());

                                if(tprefEndDate.diff(prefStartDate, 'minutes') <= 0){
                                    if(tempAvailabilityMap[workDayIndex+1] != undefined && tempAvailabilityMap[workDayIndex+1][requestPreference.employeeId] != undefined){
                                        delete tempAvailabilityMap[workDayIndex+1][requestPreference.employeeId];
                                    }
                                } */
                                }
                                if (requestPreferenceMap["" + workDayIndex] === undefined) {
                                    requestPreferenceMap["" + workDayIndex] = []
                                }
                                requestPreferenceMap["" + workDayIndex].push(Object.assign({}, requestPreference));
                                prefDate.add(1, 'days');
                                preferenceRequestId++;
                                requestPreference.id = preferenceRequestId;

                            }
                        }

                    }
                }
            }

            //iterate over remaining availabilities and add them to the request
            for (key in tempAvailabilityMap) {
                if (tempAvailabilityMap.hasOwnProperty(key)) {
                    let key2 = null;
                    for (key2 in tempAvailabilityMap[key]) {
                        if (tempAvailabilityMap[key].hasOwnProperty(key2)) {
                            let availabilities = tempAvailabilityMap[key][key2];
                            for (j = 0; j < availabilities.length; j++) {
                                preferenceRequestId++;
                                let requestAvailability = availabilities[j];
                                requestAvailability.id = preferenceRequestId;
                                if (requestPreferenceMap["" + key] === undefined) {
                                    requestPreferenceMap["" + key] = []
                                }

                                requestPreferenceMap["" + key].push(Object.assign({}, requestAvailability));
                            }
                        }
                    }

                }
            }

            //In Austria, youths and pregnant women arent allowed to work from 20:00 to 6:00, TODO: other countries?
            if (this.applyPregnancyRules || this.applyYouthRules) {
                for (key in employeeMap) {
                    let employee = employeeMap[key];

                    if (employee && employeeMapping[employeeMap[key].id] != undefined) {
                        let age = employee.dob ? currentDate.diff(this.$helpers.getMomentFromStringTZ(employee.dob), 'years') : 25;
                        let pregnant = this.calculatePregnantFlagFromContracts(employee.id);
                        let employeeId = employeeMapping[employeeMap[key].id];
                        if ((age < 18 && this.applyYouthRules) || (pregnant && this.applyPregnancyRules)) {
                            let fromHoursAdjusted = 22;
                            if (age < 16 || (pregnant && !(this.storeSettings.country == 1 && this.storeSettings.marketType == 1 && this.storeSettings.companyId != 124))) {
                                fromHoursAdjusted = 20;
                            }
                            let tempRosterStart = this.$helpers.getMomentFromValuesTZ(this.fullWeekPlanFrom.year(), this.fullWeekPlanFrom.month(), this.fullWeekPlanFrom.date(), 0, 0);
                            let tempRosterEnd = this.$helpers.getMomentFromValuesTZ(this.fullWeekPlanTo.year(), this.fullWeekPlanTo.month(), this.fullWeekPlanTo.date(), 0, 0);
                            while (tempRosterEnd.diff(tempRosterStart, 'minutes') > 0) {

                                let workDayIndex = this.calculateWorkDayIndex(tempRosterStart);
                                preferenceRequestId++;
                                let requestAvailability = {
                                    id: preferenceRequestId, // set id later after preference loop
                                    fromH: fromHoursAdjusted,
                                    fromM: 0,
                                    toH: 6,
                                    toM: 0,
                                    employeeId: employeeId,
                                    state: "UNAVAILABLE",
                                    exclusive: true,
                                    factor: 1
                                }

                                if (requestPreferenceMap["" + workDayIndex] === undefined) {
                                    requestPreferenceMap["" + workDayIndex] = []
                                }

                                requestPreferenceMap["" + workDayIndex].push(Object.assign({}, requestAvailability));
                                tempRosterStart.add(24, 'hours');

                            }
                        }
                    }
                }
            }


            let planningConfiguration = {
                maxRunTime: this.planRunTime * 60,
                unimprovedMaxTime: Math.min(3600, Math.ceil(shiftRequestId / 250) * 60),
                cores: 0,
            }


            if (!this.$helpers.isBlank(this.ruleProfile)) {

                this.rosterConfiguration.rulesSoftScoreLevels = this.ruleProfileMap[this.ruleProfile].rulesSoftScoreLevels;

            }
            customEntityMapping['hp'] = this.hp;
            if (this.hp) {
                planningConfiguration.cores = 3;
            }
            let payload = {
                storeId: "" + this.$store.state.storeId,
                ruleProfileId: this.ruleProfile,
                rosterConfiguration: this.rosterConfiguration,
                skillMap: requestSkillMap,
                spotMap: requestSpotMap,
                employeeTypeMap: requestTypeMap,
                employeeMap: requestEmployeeMap,
                timeSlotDefinitions: requestShiftMap,
                employeePreferences: requestPreferenceMap,
                customEntityMapping: customEntityMapping,
                planningConfiguration: planningConfiguration
            };
            console.log(JSON.stringify(payload));
            return payload;


        },
        checkMissingContractIntervals(employeeIds) {
            for (let i = 0; i < employeeIds.length; i++) {
                let id = employeeIds[i];
                if (this.employeeContractMap[id] != null && this.employeeContractMap[id].length > 0) {
                    let filteredContracts = this.employeeContractMap[id]
                        .filter(entry => this.$helpers.getMomentFromStringTZ(entry.from) <= this.fullWeekPlanTo && (entry.to == null || this.$helpers.getMomentFromStringTZ(entry.to).isSameOrAfter(this.fullWeekPlanFrom)))
                        .sort((a, b) => {
                            let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                            let bFrom = this.$helpers.getMomentFromStringTZ(b.from);

                            return aFrom.diff(bFrom);
                        });

                    if (filteredContracts.length > 0) {
                        let prevTo = this.fullWeekPlanFrom;
                        for (let j = 0; j < filteredContracts.length; j++) {
                            let current = filteredContracts[j];
                            let currentFrom = this.$helpers.getMomentFromStringTZ(current.from);
                            if (currentFrom.diff(prevTo, 'minutes') > 0) {
                                this.addContractUnavailablePreference(id, prevTo, currentFrom);
                            }
                            let currentTo = null;
                            if (current.to != null) {
                                currentTo = this.$helpers.getMomentFromStringTZ(current.to)
                            }
                            //check if last element in array has a to value that is smaller than fullWeekPlanTo
                            if (j == filteredContracts.length - 1 && currentTo != null && this.fullWeekPlanTo.diff(currentTo, 'minutes') > 0) {
                                this.addContractUnavailablePreference(id, currentTo, this.fullWeekPlanTo);

                            }
                            prevTo = currentTo;
                        }
                    } else {
                        //no contract where to is larger than fullWeekPlanFrom => cannot be assigned for whole month
                        this.addContractUnavailablePreference(id, this.fullWeekPlanFrom, this.fullWeekPlanTo)


                    }

                }
            }
        },
        calculateWorkTimePercentagesFromContracts(id) {
            let selectedMonth = this.currentMonthFrom.month();
            let selectedYear = this.currentMonthFrom.year();

            let startDate = this.$helpers.getCurrentMonthMomentTZ().month(selectedMonth).year(selectedYear).startOf('month');
            let endDate = startDate.clone().endOf('month').add(1, 'days').startOf('day');
            let multiplier = 1.0;
            let sum = 0;
            if (this.employeeContractMap[id] != null && this.employeeContractMap[id].length > 0) {
                let filteredContracts = this.employeeContractMap[id]
                    .filter(entry => this.$helpers.getMomentFromStringTZ(entry.from) <= endDate && (entry.to == null || this.$helpers.getMomentFromStringTZ(entry.to).isSameOrAfter(startDate)))
                    .sort((a, b) => {
                        let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                        let bFrom = this.$helpers.getMomentFromStringTZ(b.from);

                        return aFrom.diff(bFrom);
                    });

                if (filteredContracts.length > 0) {

                    filteredContracts.forEach(contract => {
                        let cFrom = this.$helpers.getMomentFromStringTZ(contract.from);
                        if (cFrom < startDate) {
                            cFrom = startDate;
                        }
                        let cTo = contract.to == null ? endDate : this.$helpers.getMomentFromStringTZ(contract.to);
                        if (cTo > endDate) {
                            cTo = endDate;
                        }
                        sum += (cTo.diff(cFrom) / endDate.diff(startDate));

                    })
                    multiplier = sum;
                }
            }

            return Math.max(0, multiplier);
        },
        calculateOvertimeCutoffs(id, storeSettings) {
            let selectedMonth = this.currentMonthFrom.month();
            let selectedYear = this.currentMonthFrom.year();

            let startDate = this.$helpers.getCurrentMonthMomentTZ().month(selectedMonth).year(selectedYear).startOf('month');
            let endDate = startDate.clone().endOf('month').add(1, 'days').startOf('day');
            let dailyOverTimeCutoff = 8 * 60;
            let weeklyOvertimeCutoff = 40 * 60;
            if (this.employeeContractMap[id] != null && this.employeeContractMap[id].length > 0) {
                let filteredContracts = this.employeeContractMap[id]
                    .filter(entry => this.$helpers.getMomentFromStringTZ(entry.from) <= endDate && (entry.to == null || this.$helpers.getMomentFromStringTZ(entry.to).isSameOrAfter(startDate)))
                    .sort((a, b) => {
                        let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                        let bFrom = this.$helpers.getMomentFromStringTZ(b.from);

                        return aFrom.diff(bFrom);
                    });

                if (filteredContracts.length > 0) {
                    let contract = filteredContracts[0];
                    dailyOverTimeCutoff = contract.overtimeCutoff;

                    if (!storeSettings.allowShiftOvertime && storeSettings.shiftOvertimeOverride > 0) {
                        dailyOverTimeCutoff = storeSettings.shiftOvertimeOverride;
                    }
                    weeklyOvertimeCutoff = contract.weeklyOvertimeCutoff

                    if (!storeSettings.allowWeeklyOvertime && storeSettings.weekOvertimeOverride > 0) {
                        weeklyOvertimeCutoff = storeSettings.weekOvertimeOverride;
                    }

                }
            }


            return {overtimeCutoff: dailyOverTimeCutoff, weeklyOvertimeCutoff: weeklyOvertimeCutoff}
        },
        calculatePregnantFlagFromContracts(id) {
            let selectedMonth = this.currentMonthFrom.month();
            let selectedYear = this.currentMonthFrom.year();

            let startDate = this.$helpers.getCurrentMonthMomentTZ().month(selectedMonth).year(selectedYear).startOf('month');
            let endDate = startDate.clone().endOf('month').add(1, 'days').startOf('day');
            let pregnant = false;
            if (this.employeeContractMap[id] != null && this.employeeContractMap[id].length > 0) {
                let filteredContracts = this.employeeContractMap[id]
                    .filter(entry => this.$helpers.getMomentFromStringTZ(entry.from) <= endDate && (entry.to == null || this.$helpers.getMomentFromStringTZ(entry.to).isSameOrAfter(startDate)))
                    .sort((a, b) => {
                        let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                        let bFrom = this.$helpers.getMomentFromStringTZ(b.from);

                        return aFrom.diff(bFrom);
                    });

                if (filteredContracts.length > 0) {

                    filteredContracts.forEach(contract => {
                        if (contract.pregnant) {
                            pregnant = true;
                        }

                    })

                }
            }

            return pregnant;
        },
        getMainContract(id, from, to) {
            let contract = null;
            if (this.employeeContractMap[id] != null && this.employeeContractMap[id].length > 0) {
                let filteredContracts = this.employeeContractMap[id]
                    .filter(entry => this.$helpers.getMomentFromStringTZ(entry.from) <= to && (entry.to == null || this.$helpers.getMomentFromStringTZ(entry.to).isSameOrAfter(from)))
                    .sort((a, b) => {
                        let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                        let bFrom = this.$helpers.getMomentFromStringTZ(b.from);

                        return aFrom.diff(bFrom);
                    });

                if (filteredContracts.length > 0) {
                    contract = filteredContracts[0];
                }
            }
            return contract;
        },
        addContractUnavailablePreference(employeeId, from, to, workValue = 0) {
            let tEmployeePreference = {
                id: this.generateUUID(),
                employeeId: employeeId,
                from: from.format(),
                to: to.format(),
                state: 1,
                type: 5,
                workValue: workValue,
                exclusive: true,
                deleted: false,
                approved: true,
                overrideContratc: true,
                factor: 1,
                storeId: this.$store.state.storeId
            }
            let employee = "";
            if (employeeId != null) {
                employee = this.employeeMap[employeeId].firstName + " " + this.employeeMap[employeeId].lastName;
            }
            let tOption = {
                id: tEmployeePreference.id,
                state: tEmployeePreference.state,
                type: tEmployeePreference.type,
                workValue: tEmployeePreference.workValue,
                from: from.format("DD.MM.YYYY HH:mm"),
                to: to.format("DD.MM.YYYY HH:mm"),
                employee: employee,
                spot: "",
                value: tEmployeePreference,
                checked: true
            }
            this.employeePreferenceOptions.push(tOption);
        },
        calculateEmployeeAvailabilityOptions(data) {
            let availabilityOptions = []

            let weekDaysArray = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
            for (let i = 0; i < data.length; i++) {
                let weekdays = "";
                for (let j = 0; j < data[i].weekDays.length; j++) {
                    weekdays += weekDaysArray[data[i].weekDays[j] - 1] + ", "
                }
                if (weekdays.length > 2) {
                    weekdays = weekdays.slice(0, -2);
                }
                let position = "";
                if (data[i].spotId != null) {
                    position = this.spotMap[data[i].spotId].name;
                }
                let employee = "";
                if (data[i].employeeId != null) {
                    employee = this.employeeMap[data[i].employeeId].firstName + " " + this.employeeMap[data[i].employeeId].lastName;
                }

                let tOption = {
                    id: data[i].id,
                    state: data[i].state,
                    from: data[i].from,
                    to: data[i].to,
                    employee: employee,
                    spot: position,
                    type: data[i].type,
                    weekdays: weekdays,
                    value: data[i],
                    checked: true
                }
                availabilityOptions.push(tOption);
            }
            this.employeeAvailabilityOptions = availabilityOptions;
        },
        calculateEmployeePreferenceOptions(data) {
            let preferenceOptions = []
            var i;
            for (i = 0; i < data.length; i++) {

                let position = "";
                if (data[i].spotId != null) {
                    position = this.spotMap[data[i].spotId].name;
                }
                let employee = "";
                if (data[i].employeeId != null) {
                    employee = this.employeeMap[data[i].employeeId].firstName + " " + this.employeeMap[data[i].employeeId].lastName;
                }
                let fromMoment = this.$helpers.getMomentFromStringTZ(data[i].from);
                let tOption = {
                    id: data[i].id, state: data[i].state, type: data[i].type, workValue: data[i].workValue,
                    from: fromMoment.format("DD.MM.YYYY HH:mm"),
                    to: this.$helpers.getMomentFromStringTZ(data[i].to).format("DD.MM.YYYY HH:mm"),
                    week: fromMoment.isoWeek(),
                    year: fromMoment.isoWeekYear(),
                    employee: employee, spot: position, value: data[i], checked: true
                }
                preferenceOptions.push(tOption);
            }
            this.employeePreferenceOptions = preferenceOptions;
        },
        calculateShiftOptions() {
            let shiftOptions = [];
            let impossibleShiftOptions = [];
            Object.values(this.shiftMap).forEach(shift => {
                let position = "";

                if (shift.spotId != null) {
                    position = this.spotMap[shift.spotId].name;
                }
                let employee = "";
                if (shift.employeeId != null) {
                    if (this.employeeMap[shift.employeeId] == null) {
                        employee = this.$t('roster.main.invalidEmployee')
                    } else {
                        employee = this.employeeMap[shift.employeeId].firstName + " " + this.employeeMap[shift.employeeId].lastName;
                    }

                }
                if (this.selectedSpots.includes(shift.spotId)) {
                    let shiftIsPossible = false;
                    for (let employeeId in this.employeeMap) {
                        if (this.checkEmployeeCanDoShift(employeeId, shift.id, shift.spotId)) {
                            shiftIsPossible = true;
                            break;
                        }
                    }
                    let fromMoment = this.$helpers.getMomentFromStringTZ(shift.from);
                    let tOption = {
                        id: shift.id,
                        spot: position,
                        employee: employee,
                        from: fromMoment.format("DD.MM.YYYY HH:mm"),
                        to: this.$helpers.getMomentFromStringTZ(shift.to).format("DD.MM.YYYY HH:mm"),
                        week: fromMoment.isoWeek(),
                        year: fromMoment.isoWeekYear(),
                        checked: true,
                        disabled: false,
                        noplan: false
                    };
                    //check if employee got actual shift on same day, if yes => dont send shift to autoscheduler
                    if (this.useActualShifts && shift.employeeId != null && this.employeeDateActualShiftMap[shift.employeeId]) {
                        let employeeActualShiftEntry = this.employeeDateActualShiftMap[shift.employeeId];
                        let key = fromMoment.format("YYYY-MM-DD");
                        if (employeeActualShiftEntry[key] && employeeActualShiftEntry[key].length > 0) {
                            tOption.checked = false;
                            tOption.disabled = true;
                            tOption.noplan = true;
                        }
                    }
                    if (shiftIsPossible) {
                        shiftOptions.push(tOption);
                    } else {
                        impossibleShiftOptions.push(tOption);
                    }
                }
            });

            this.shiftOptions = shiftOptions;
            this.impossibleShiftOptions = impossibleShiftOptions;
        },
        calculateActualShiftOptions() {
            let actualShiftOptions = [];
            Object.values(this.actualShiftMap).forEach(shift => {
                if (this.employeeMap[shift.employeeId] != null) {
                    let employee = this.employeeMap[shift.employeeId].firstName + " " + this.employeeMap[shift.employeeId].lastName;
                    let fromMoment = this.$helpers.getMomentFromStringTZ(shift.from);
                    let tOption = {
                        id: shift.id,
                        employee: employee,
                        from: fromMoment.format("DD.MM.YYYY HH:mm"),
                        to: this.$helpers.getMomentFromStringTZ(shift.to).format("DD.MM.YYYY HH:mm"),
                        week: fromMoment.isoWeek(),
                        year: fromMoment.isoWeekYear()
                    };
                    actualShiftOptions.push(tOption);
                }
            });
            this.actualShiftOptions = actualShiftOptions;
        },
        generateUUID: function () {
            //https://jcward.com/UUID.js
            let lut = [];
            for (var i = 0; i < 256; i++) {
                lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
            }
            let d0 = Math.random() * 0xffffffff | 0;
            let d1 = Math.random() * 0xffffffff | 0;
            let d2 = Math.random() * 0xffffffff | 0;
            let d3 = Math.random() * 0xffffffff | 0;
            return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
                lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
                lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
                lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
        },
        loadRuleProfiles: function () {

            let url = '/api/sec/ruleprofile';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruleprofile');


            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).catch(error =>
                Promise.reject({msg: this.$t('roster.main.loadingProfilesError')})
            )

        },
        loadBusinessUnits: function () {
            return this.$helpers.GetBusinessUnitMap(false, false);
        },
        loadEmployeeTypeTemplates: function () {
            return this.$helpers.GetEmployeeTypeTemplateMap(false, false);
        },
        loadSpots: function () {
            return this.$helpers.GetSpotMap(false, false);
        },
        loadHolidays: function () {
            return this.$helpers.GetHolidayMap(false);
        },
        loadShiftsAnySpotAnyEmployee: function (spotPayload, employeePayload) {
            if (this.$helpers.isBlank(spotPayload.ids) || spotPayload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/planshift/any/spot/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.fullWeekPlanFrom.format(),
                    to: this.fullWeekPlanTo.format()
                }


                let payload = {
                    spotIds: spotPayload,
                    employeeIds: employeePayload
                };
                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingShiftsError')})
                )
            }
        },
        loadEmployeeContractsAnyEmployee: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeecontract/any/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.fullWeekPlanFrom.format(),
                    to: this.fullWeekPlanTo.format()
                }


                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingContractsError')})
                )
            }
        },
        loadShiftSkillsAnyShift: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/shiftskillrequirement/any/shift';

                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement/any/shift');

                return this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingSkillsError')})
                )
            }
        },
        loadSkills: function () {

            return this.$helpers.GetSkillMap(false, false);

        },
        loadEmployeesAnySkill: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employee/any/skill';
                let params = {
                    storeId: this.$store.state.storeId,
                    hastype: true,
                    activeAtFrom: this.fullWeekPlanFrom.format(),
                    activeAtTo: this.fullWeekPlanTo.format(),
                    active: true,
                }


                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingEmployeeError')})
                )
            }
        },
        loadEmployeeSkillsAnyEmployee: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeeskill/any/employee';

                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill/any/employee');

                return this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingEmployeeSkillsError')})
                )
            }
        },
        loadEmployeeRulesAny: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeerules/any';

                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules/any');

                return this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingEmployeeRulesError')})
                )
            }
        },
        loadEmployeeTypeAny: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({});
                })
            } else {
                return this.$helpers.GetEmployeeTypeMap().then(map => {
                    let resultMap = {};
                    Object.values(map).filter(type => payload.ids.includes(type.id)).forEach(type => resultMap[type.id] = type);
                    return new Promise((resolve, reject) => {
                        resolve(resultMap);
                    })
                });
            }
        },
        loadEmployeeWeeklyParametersAnyEmployee: function (payload) {

            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({});
                })
            } else {
                return this.$helpers.GetEmployeeWeeklyParametersMap().then(map => {
                    let resultMap = {};
                    Object.values(map).filter(params => payload.ids.includes(params.employeeId)).forEach(params => resultMap[params.id] = params);
                    return new Promise((resolve, reject) => {
                        resolve(resultMap);
                    })
                });
            }
        },
        loadEmployeeAvailabilityAnyEmployee: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeeavailability/any/employee';

                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability/any/employee');

                return this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingEmployeeAvailabilityError')})
                )
            }
        },
        loadEmployeePreferenceAnyEmployee: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeepreference/any/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.fullWeekPlanFrom.format(),
                    to: this.fullWeekPlanTo.format(),
                    approved: true
                }


                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingWishesError')})
                )
            }
        },
        loadPreviousMonthEmployeeWorkBalances: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/any/employee';
                let from = this.currentMonthFrom.clone().subtract(1, 'months').startOf('month');

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 1).format(),
                    to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).catch(error =>
                    Promise.reject({msg: this.$t('roster.main.loadingMonthEndError')})
                )
            }

        },
        updatePreviousMonthEmployeeWorkBalances: function (data) {
            let previousMonthWorkBalanceMap = {};
            for (let i = 0; i < data.length; i++) {
                previousMonthWorkBalanceMap[data[i].employeeId] = data[i];
            }
            this.previousMonthWorkBalanceMap = previousMonthWorkBalanceMap;
        },
        updateUIData: function (data) {
            this.uiData = data;
            let stateMap = {};
            let typeMap = {};
            for (let i = 0; i < data.employeeAvailabilityStates.length; i++) {
                let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;
            }
            for (let i = 0; i < data.employeeAvailabilityTypes.length; i++) {
                let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;
            }
            this.employeeAvailabilityStateMap = stateMap;
            this.employeeAvailabilityTypeMap = typeMap;
        },

        submitRosterRequest: function (payload) {

            let url = '/api/sec/employeeroster';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster');

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error =>
                Promise.reject({msg: this.$t('roster.main.sendPlanError')})
            )

        },
        calculateWorkDayIndex: function (EndDate) {
            let fixedEndDate = EndDate.clone().hours(0).minutes(0).seconds(0).milliseconds(0);
            let StartDate = this.$helpers.getMomentFromValuesTZ(this.rosterConfiguration.year, this.rosterConfiguration.month - 1, 1);
            let nDays = fixedEndDate.diff(StartDate, 'days');

            return nDays + 1; //workDay Index starts with 1
        },
        extractDate: function (str) {
            if (!this.$helpers.isBlank(str)) {
                let split = str.split("T");
                return split[0];
            } else {
                return null;
            }
        },
        extractTime: function (str) {
            if (!this.$helpers.isBlank(str)) {
                let split1 = str.split("T");
                let split2 = split1[1].split(":")
                return split2[0] + ":" + split2[1];
            } else {
                return null;
            }
        },
        getMinuteDiff: function (from, to) {
            var diff = (to.getTime() - from.getTime()) / 1000;
            diff /= 60;
            return Math.round(diff);
        },
        getMinuteDiffAbs: function (from, to) {
            var diff = (to.getTime() - from.getTime()) / 1000;
            diff /= 60;
            return Math.abs(Math.round(diff));
        },

    },
}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>
.col .form-text.text-muted {
    display: none;
}

.col .form-text.text-muted {
    display: none;
}

.slider {
    margin-top: 10px;
    margin-bottom: -10px;
}

.form-row {
    margin-top: 25px;
    margin-bottom: 25px;
}

.fa-spinner {
    width: 60px;
    height: 60px;
    font-size: 60px;
    color: var(--md);
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    overflow: hidden !important;
}

.footer {
    position: absolute;
    z-index: 100;
    bottom: 0;
    width: 100%;
    left: 0;
    height: 60px;
    background: white;
    box-shadow: 0 -3px 0 -2px var(--contrast-3);
    align-items: center;
    padding: 0 20px;
}

.label.header.large {
    transform: translateY(-10px);
    margin-top: -20px;
}

.md-group {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    text-align: left;
    padding: 5px 15px;
    justify-content: left;
    width: 100%;
}

.md-group.inline {
    padding-left: 0;
    padding-right: 8px;
    margin-right: 16px;
    width: auto;
}

.md-group .label {
    font-size: 14px;
}

.md-group.inline.border-right{
    border-right: solid 1px var(--contrast-3);
}

.md-group.border-right {
    padding-right: 30px;
}

.md-card-select {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
}

.md-card-select.tabbar{
    border-bottom: solid 2px var(--md);
}

.md-card-select.noborder {
    border: none;
    padding: 0 15px 0;
}

.md-card-select.pad-top-bottom{
    padding-top: 8px;
    padding-bottom: 6px;
}

.md-card-select .label {
    /* width: 11em; */
    width: 140px;
    font-size: 14px !important;
    font-weight: bold !important;
}

.md-card-select .header {
    font-size: 16px !important;
    font-weight: bold !important;
}

.md-card-select .wide-label {
    width: 400px;
}

.w400 {
    width: 400px;
}

.slide-container {
    width: 250px;
    padding-top: 10px;
    padding-bottom: 15px;
    margin-left: 30px;
}

.md-tab-body {
    width: 100%;
    margin-bottom: 10px;
}

.cb-group {
    display: flex;
    height: 20px;
    align-self: center;
}

.explain {
    width: 100%;
    font-size: 11px;
    color: var(--contrast-4);
    padding-top: 8px;
}

.small-table {
    max-width: 600px;
}

.md-card {
    max-width: 90vw;
    width: 1280px;
    height: calc(98vh - 139px);
    border: none;
}

.md-card-body {
    max-height: none;
}

.center {
    display:flex;
    justify-content:center;
    align-content: center;
}

.cd-input {
    margin: -2px 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
    align-items: center!important;
    padding-bottom: 6px;
}
</style>
